/**
 * SARATTI — Gemstone Ring Builder
 * gemstone-builder.js
 * Version: 70.0.0
 */
(function () {
  'use strict';
  const cfg = window.GRB_CONFIG || {};
  const state = { tab: 0, settingIndex: cfg.settings && cfg.settings.length ? 0 : -1, selectedOptions: {}, selectedVariant: null, size: '', engraving: '', sizerRequested: false, modalSettingIndex: cfg.settings && cfg.settings.length ? 0 : -1, modalOptions: {}, modalDescOpen: false };
  const preloadedImages = new Set();
  let processRotationTimer = null;
  let processRotationIndex = 0;
  let processRotationType = 'stone';
  function cents(v){ if(v===null||v===undefined||v==='')return 0; if(typeof v==='number')return Math.round(v); return Math.round(parseFloat(String(v).replace(/[^0-9.-]/g,'')||'0')*100); }
  function money(c){ const a=(c||0)/100; return '$'+a.toLocaleString('en-US',{minimumFractionDigits:a%1===0?0:2,maximumFractionDigits:2}); }
  function escapeHtml(v){ return String(v||'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch])); }
  function escapeAttr(v){ return escapeHtml(v).replace(/`/g,'&#096;'); }
  function normalizeKey(k){ return String(k||'').toLowerCase().replace(/colour/g,'color').replace(/certificate/g,'certification').replace(/[^a-z0-9]+/g,' ').trim(); }
  function htmlToText(html){ if(!html)return ''; const d=document.createElement('div'); d.innerHTML=html; return d.innerText||d.textContent||''; }
  function cleanValue(v){ if(v===null||v===undefined)return ''; let out=String(v).trim(); if(!out)return ''; try{const p=JSON.parse(out); if(Array.isArray(p))out=p.join(', '); else if(typeof p==='string')out=p;}catch(_){} return String(out).replace(/^["']|["']$/g,'').trim(); }
  function parseGemstoneDetails(html){ const t=htmlToText(html), details={}; t.split(/\n+/).map(l=>l.trim()).filter(Boolean).forEach(l=>{const m=l.match(/^([^:：]+)[:：]\s*(.+)$/); if(m)details[normalizeKey(m[1])]=cleanValue(m[2]);}); return details; }
  function getStoneDetails(){ const parsed=parseGemstoneDetails(cfg.gemstoneDetailsHtml), old=cfg.oldMetafields||{}; const value=(...keys)=>{for(const k of keys){const n=normalizeKey(k); if(parsed[n])return cleanValue(parsed[n]);} for(const k of keys){ if(old[k])return cleanValue(old[k]); } return '';}; return {gemstoneType:value('gemstone type')||old.gemstoneType||'', weight:value('carat weight','weight','caratWeight'), shape:value('shape'), cut:value('cut'), color:value('color','stone_color'), clarity:value('clarity'), dimensions:value('dimensions'), treatment:value('treatment'), origin:value('origin'), certificate:value('certification','certificate')||'SARATTI', title:cfg.stoneTitle||''}; }
  function currentSetting(){ return cfg.settings&&cfg.settings.length ? (cfg.settings[state.settingIndex]||cfg.settings[0]||null) : null; }
  function modalSetting(){ return cfg.settings&&cfg.settings.length ? (cfg.settings[state.modalSettingIndex]||cfg.settings[0]||null) : null; }
  function optionValue(variant,name){ const opt=(variant&&variant.selectedOptions||[]).find(o=>normalizeKey(o.name)===normalizeKey(name)); return opt?opt.value:''; }
  function optionsMatch(variant,selections){ return Object.keys(selections||{}).every(name=>optionValue(variant,name)===selections[name]); }
  function firstAvailableVariant(setting){ return setting&&Array.isArray(setting.variants) ? (setting.variants.find(v=>v.available)||setting.variants[0]||null) : null; }
  function selectedOptionsFromVariant(variant){ const out={}; (variant&&variant.selectedOptions||[]).forEach(o=>out[o.name]=o.value); return out; }
  function findVariant(setting,selections){ if(!setting||!Array.isArray(setting.variants))return null; return setting.variants.find(v=>optionsMatch(v,selections)&&v.available)||setting.variants.find(v=>optionsMatch(v,selections))||firstAvailableVariant(setting); }
  function getSelectedVariant(){ state.selectedVariant=findVariant(currentSetting(),state.selectedOptions); return state.selectedVariant; }
  function getModalVariant(){ return findVariant(modalSetting(),state.modalOptions); }
  function isOptionValueAvailable(setting, optionName, value, selections){ if(!setting||!setting.variants)return false; const test={...(selections||{}),[optionName]:value}; return setting.variants.some(v=>optionsMatch(v,test)&&v.available); }
  function variantPrice(v){ return v?cents(v.price):0; }
  function totalPrice(){ return cents(cfg.stonePrice)+variantPrice(getSelectedVariant()); }
  function preloadImage(src){ if(!src||preloadedImages.has(src))return; preloadedImages.add(src); const img=new Image(); img.decoding='async'; img.src=src; }
  function preloadImages(images){ (images||[]).forEach(img=>{preloadImage(img&&img.src); preloadImage(img&&img.thumb);}); }
  function preloadAllBuilderImages(){ preloadImages(cfg.stoneImages||[]); (cfg.settings||[]).forEach(s=>{preloadImages(s.images||[]); preloadImage(s.featuredImage); (s.variants||[]).forEach(v=>{ if(v.image){preloadImage(v.image.src); preloadImage(v.image.thumb);} });}); }
  function setMainImg(src){ const el=document.getElementById('grb-main-img'); if(!el||!src||el.src===src)return; el.src=src; }
  function imageAltMatches(img,value){ const alt=String((img&&(img.altText||img.alt))||'').toLowerCase(), v=String(value||'').toLowerCase(); if(!alt||!v)return false; if(v.includes('yellow'))return alt.includes('yellow'); if(v.includes('white'))return alt.includes('white'); if(v.includes('rose'))return alt.includes('rose'); if(v.includes('platinum'))return alt.includes('platinum'); if(v.includes('silver'))return alt.includes('silver'); return alt.includes(v); }
  function imagesForSelections(setting,selections){ if(!setting)return []; const variant=findVariant(setting,selections), variantImg=variant&&variant.image&&variant.image.src?variant.image:null, images=Array.isArray(setting.images)?setting.images:[]; const metalName=Object.keys(selections||{}).find(k=>normalizeKey(k).includes('metal')||normalizeKey(k).includes('material')); const metalValue=metalName?selections[metalName]:''; const matched=metalValue?images.filter(img=>imageAltMatches(img,metalValue)):[]; const unique=[]; const add=img=>{if(!img||!img.src)return; if(unique.some(x=>x.src===img.src))return; unique.push(img);}; add(variantImg); (matched.length?matched:images).forEach(add); if(!unique.length&&setting.featuredImage)unique.push({src:setting.featuredImage,thumb:setting.featuredImage,altText:setting.title}); return unique; }
  function buildThumbs(images){ const strip=document.getElementById('grb-thumbstrip'); if(!strip)return; strip.innerHTML=''; (images||[]).forEach((image,i)=>{const src=typeof image==='string'?image:image.src, thumb=typeof image==='string'?image:(image.thumb||image.src); if(!src)return; const d=document.createElement('div'); d.className='grb__thumb'+(i===0?' grb__thumb--active':''); d.setAttribute('role','button'); d.setAttribute('tabindex','0'); const img=document.createElement('img'); img.src=thumb; img.alt=(image&&(image.altText||image.alt))||'View '+(i+1); img.loading='lazy'; d.appendChild(img); d.addEventListener('mouseenter',()=>preloadImage(src)); d.addEventListener('touchstart',()=>preloadImage(src),{passive:true}); d.addEventListener('click',()=>{strip.querySelectorAll('.grb__thumb').forEach(t=>t.classList.remove('grb__thumb--active')); d.classList.add('grb__thumb--active'); setMainImg(src);}); strip.appendChild(d);}); const first=images&&images[0]; if(first)setMainImg(typeof first==='string'?first:first.src); }
  function renderStoneSpecs(){ const details=getStoneDetails(), grid=document.getElementById('grb-spec-grid'), table=document.getElementById('grb-spec-table'), badges=document.getElementById('grb-stone-badges'), eyebrow=document.getElementById('grb-stone-eyebrow'), trustCert=document.getElementById('grb-trust-cert'); const specs=[['Weight',details.weight],['Shape',details.shape],['Dimensions',details.dimensions],['Clarity',details.clarity],['Treatment',details.treatment],['Colour',details.color]].filter(x=>x[1]); if(grid)grid.innerHTML=specs.map(([l,v])=>`<div class="grb__spec"><div class="grb__spec-label">${escapeHtml(l)}</div><div class="grb__spec-val">${escapeHtml(v)}</div></div>`).join(''); const rows=[['Gemstone Type',details.gemstoneType],['Carat Weight',details.weight],['Shape',details.shape],['Cut',details.cut],['Colour',details.color],['Clarity',details.clarity],['Dimensions',details.dimensions],['Treatment',details.treatment],['Origin',details.origin],['Certificate',details.certificate]].filter(x=>x[1]); if(table)table.innerHTML=rows.map(([l,v])=>`<div class="grb__spec-list-row"><span>${escapeHtml(l)}</span><strong>${escapeHtml(v)}</strong></div>`).join(''); if(eyebrow)eyebrow.textContent=[details.gemstoneType||cfg.productType,details.shape,details.treatment].filter(Boolean).join(' · '); if(trustCert)trustCert.textContent=details.certificate||'SARATTI'; if(badges){const ready=cfg.stoneAvailable?'<span class="grb__badge">Ready to ship</span>':''; const treatment=details.treatment?`<span class="grb__badge">${escapeHtml(details.treatment)}</span>`:''; const cert=`<span class="grb__badge">${escapeHtml(details.certificate||'SARATTI')} certified</span>`; badges.innerHTML=treatment+cert+ready;} }
  function renderSettings(){ const grid=document.getElementById('grb-settings-grid'); if(!grid)return; if(!cfg.settings||!cfg.settings.length){grid.innerHTML='<div class="grb__empty"><strong>No compatible settings linked yet.</strong><span>Add setting products to this gemstone using the product metafield custom.ring_settings.</span></div>'; return;} grid.innerHTML=cfg.settings.map((s,i)=>{const v=firstAvailableVariant(s), img=(v&&v.image&&v.image.src)||s.featuredImage||(s.images&&s.images[0]&&s.images[0].src)||'', price=variantPrice(v); return `<div class="grb__scard ${i===state.settingIndex?'grb__scard--selected':''}" id="grb-scard-${i}" onclick="GRB.pickSetting(${i})"><div class="grb__scard-img">${img?`<img id="grb-scard-${i}-img" src="${escapeAttr(img)}" alt="${escapeAttr(s.title||'Ring setting')}" loading="lazy">`:'<span class="grb__scard-placeholder">No image</span>'}<button class="grb__preview-btn" type="button" onclick="GRB.openPreview(event, ${i})">Preview</button></div><div class="grb__scard-foot"><div class="grb__scard-name">${escapeHtml(s.title||'Setting')}</div><div class="grb__scard-price">${price?'from '+money(price):'Price on selection'}</div></div></div>`;}).join(''); }
  function initialiseSettingSelection(i){ const s=cfg.settings&&cfg.settings[i]; if(!s)return; const v=firstAvailableVariant(s); state.selectedOptions=selectedOptionsFromVariant(v); state.selectedVariant=v; }
  function goTab(n){ state.tab=n; if(n>0)document.getElementById('grb-tab-0')?.classList.add('grb__tab--done'); if(n>1)document.getElementById('grb-tab-1')?.classList.add('grb__tab--done'); [0,1,2].forEach(i=>{const tab=document.getElementById('grb-tab-'+i), panel=document.getElementById('grb-panel-'+i); if(tab){tab.classList.toggle('grb__tab--active',i===n); tab.setAttribute('aria-selected',i===n?'true':'false');} if(panel)panel.classList.toggle('grb__panel--active',i===n);}); if(n===0)buildThumbs(cfg.stoneImages||[]); else buildThumbs(imagesForSelections(currentSetting(),state.selectedOptions)); updateHeader(); updateSummary(); updateStickyBar(); updateLuxuryStickyBar(); updateBuildContext(); repairSelectedSettingContextImage(); window.scrollTo({top:0,behavior:'smooth'}); }
  function pickSetting(i){ if(!cfg.settings||!cfg.settings[i])return; state.settingIndex=Number(i); state.modalSettingIndex=state.settingIndex; initialiseSettingSelection(state.settingIndex); document.querySelectorAll('.grb__scard').forEach(c=>c.classList.remove('grb__scard--selected')); document.getElementById('grb-scard-'+state.settingIndex)?.classList.add('grb__scard--selected'); if(state.tab>0)buildThumbs(imagesForSelections(currentSetting(),state.selectedOptions)); updateSummary(); updateHeader(); updateStickyBar(); updateLuxuryStickyBar(); updateBuildContext(); repairSelectedSettingContextImage(); }
  function guideKeyForOption(name,value){ const n=normalizeKey(name), v=String(value||''); if(n.includes('metal')||n.includes('material')){ if(/18\s*k/i.test(v))return{group:'metal',key:'18K Gold'}; if(/14\s*k/i.test(v))return{group:'metal',key:'14K Gold'}; if(/9\s*k/i.test(v))return{group:'metal',key:'9K Gold'}; if(/925|sterling/i.test(v))return{group:'metal',key:'925 Sterling Silver'}; if(/platinum/i.test(v))return{group:'metal',key:'Platinum'}; } if(n.includes('side')||n.includes('stone')||n.includes('diamond')){ if(/natural diamond/i.test(v))return{group:'side',key:'Natural Diamonds'}; if(/lab/i.test(v)&&/diamond/i.test(v))return{group:'side',key:'Lab Grown Diamonds'}; } return null; }
  function guideContentFor(name,value){ const m=guideKeyForOption(name,value); if(!m)return ''; return ((((cfg.guides||{})[m.group]||{})[m.key])||'').trim(); }
  function guideTitleFor(name,value){ const m=guideKeyForOption(name,value); return m?m.key:value; }
  function metalSwatchClass(value) {
    const selected = String(value || '').toLowerCase();

    if (selected.includes('yellow')) return 'grb__metal-swatch--yellow';
    if (selected.includes('rose')) return 'grb__metal-swatch--rose';
    if (selected.includes('white')) return 'grb__metal-swatch--white';
    if (selected.includes('platinum')) return 'grb__metal-swatch--pt';
    if (selected.includes('silver') || selected.includes('925')) return 'grb__metal-swatch--silver';

    return 'grb__metal-swatch--neutral';
  }

  function isMetalOption(optionName) {
    const name = normalizeKey(optionName);
    return name.includes('metal') || name.includes('material');
  }

  function renderModalOptions() {
    const s = modalSetting();
    const wrap = document.getElementById('grb-modal-options');

    if (!s || !wrap) return;

    wrap.innerHTML = (s.options || []).map(option => {
      const values = option.values || [];
      const metal = isMetalOption(option.name);

      const buttons = values.map(value => {
        const active = state.modalOptions[option.name] === value;
        const available = isOptionValueAvailable(s, option.name, value, state.modalOptions);

        if (metal) {
          return `<button class="grb__metal-option ${active ? 'grb__metal-option--active' : ''}" ${available ? '' : 'disabled'} type="button" onclick="GRB.modalPickOption('${escapeAttr(option.name)}','${escapeAttr(value)}')" aria-label="${escapeAttr(value)}" title="${escapeAttr(value)}"><span class="grb__metal-swatch ${metalSwatchClass(value)}"></span></button>`;
        }

        return `<button class="grb__option-pill ${active ? 'grb__option-pill--active' : ''}" ${available ? '' : 'disabled'} type="button" onclick="GRB.modalPickOption('${escapeAttr(option.name)}','${escapeAttr(value)}')">${escapeHtml(value)}</button>`;
      }).join('');

      const current = state.modalOptions[option.name] || values[0] || '';
      const guide = guideContentFor(option.name, current);
      const icon = guide ? `<button class="grb__info-btn" type="button" onclick="GRB.openVariantGuide('${escapeAttr(option.name)}','${escapeAttr(current)}')" aria-label="Open ${escapeAttr(option.name)} guide"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg></button>` : '';

      return `<div class="grb__variant-row ${metal ? 'grb__variant-row--metal' : ''}"><div class="grb__config-label">${escapeHtml(option.name)}${icon}</div><div class="${metal ? 'grb__metal-options' : 'grb__variant-pills'}">${buttons}</div><div class="grb__selected-option">${escapeHtml(current)}</div></div>`;
    }).join('');
  }

  function modalPickOption(name,value){ state.modalOptions[name]=value; const v=findVariant(modalSetting(),state.modalOptions); if(v)state.modalOptions=selectedOptionsFromVariant(v); refreshModal(); }
  function renderToneChips(name,value){ const m=guideKeyForOption(name,value); if(!m||m.group!=='metal')return ''; if(m.key==='Platinum')return '<div class="grb__tone-row"><span class="grb__tone grb__tone--pt"></span><span>Natural white platinum tone</span></div>'; if(m.key==='925 Sterling Silver')return '<div class="grb__tone-row"><span class="grb__tone grb__tone--silver"></span><span>Bright silver-white tone</span></div>'; return '<div class="grb__tone-grid"><div class="grb__tone-row"><span class="grb__tone grb__tone--yellow"></span><span>Yellow tone</span></div><div class="grb__tone-row"><span class="grb__tone grb__tone--white"></span><span>White tone</span></div><div class="grb__tone-row"><span class="grb__tone grb__tone--rose"></span><span>Rose tone</span></div></div>'; }
  function openVariantGuide(name,value){ const content=guideContentFor(name,value); if(!content)return; const title=document.getElementById('grb-guide-title'), body=document.getElementById('grb-guide-body'); if(title)title.textContent=guideTitleFor(name,value); if(body)body.innerHTML=`<div class="grb__guide-intro"><div class="grb__guide-kicker">SARATTI material guide</div><h3>${escapeHtml(guideTitleFor(name,value))}</h3></div>${renderToneChips(name,value)}<div class="grb__drawer-item"><div class="grb__drawer-copy">${content}</div></div>`; document.getElementById('grb-guide-drawer')?.classList.add('grb__drawer-bg--open'); }
  function iconSvg(icon){ const base='width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"'; if(icon==='diamond')return `<svg ${base}><path d="M6 3h12l4 6-10 12L2 9l4-6z"/><path d="M2 9h20M6 3l6 18 6-18"/></svg>`; if(icon==='advisor')return `<svg ${base}><path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/></svg>`; if(icon==='shipping')return `<svg ${base}><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="18" cy="17" r="2"/></svg>`; if(icon==='certificate')return `<svg ${base}><circle cx="12" cy="8" r="5"/><path d="M9 13l-1 8 4-2 4 2-1-8"/></svg>`; if(icon==='details')return `<svg ${base}><path d="M4 5h16M4 12h16M4 19h10"/></svg>`; return ''; }
  function previewBlockContent(block, setting) {
    const source = block && block.contentSource ? block.contentSource : 'manual';

    if (source === 'setting_features') {
      return (setting && setting.features) || block.content || '';
    }

    if (source === 'setting_ring_details') {
      return (setting && setting.ringDetails) || block.content || '';
    }

    if (source === 'setting_description') {
      return (setting && setting.description) || block.content || '';
    }

    return block.content || '';
  }

function isPreviewSpecificationBlock(block) {
  return false;
}

  function isSpecLineText(text) {
    return /^([^:：]{1,80})[:：]\s*(.+)$/.test(
      String(text || '').replace(/\s+/g, ' ').trim()
    );
  }


  function splitHtmlLines(html) {
    if (!html) return [];

    const root = document.createElement('div');
    root.innerHTML = html;

    root.querySelectorAll('br').forEach(br => {
      br.replaceWith(document.createTextNode('\n'));
    });

    root.querySelectorAll('p, div, li, tr, h1, h2, h3, h4, h5, h6').forEach(el => {
      el.appendChild(document.createTextNode('\n'));
    });

    return (root.innerText || root.textContent || '')
      .split(/\n+/)
      .map(line => line.replace(/\s+/g, ' ').trim())
      .filter(Boolean);
  }

  function linesToParagraphHtml(lines) {
    const cleaned = (lines || [])
      .map(line => String(line || '').replace(/\s+/g, ' ').trim())
      .filter(Boolean);

    if (!cleaned.length) return '';

    return cleaned.map(line => '<p>' + escapeHtml(line) + '</p>').join('');
  }

  function previewSpecAllowedKeys() {
    return new Set([
      'gemstone type',
      'stone type',
      'main stone',
      'center stone',
      'centre stone',
      'carat weight',
      'weight',
      'stone size range',
      'gemstone shape',
      'shape',
      'cut',
      'color',
      'colour',
      'clarity',
      'dimensions',
      'measurement',
      'measurements',
      'treatment',
      'origin',
      'species',
      'variety',
      'transparency',
      'hardness',
      'luster',
      'lustre',
      'refractive index',
      'specific gravity',
      'side stones',
      'side stone',
      'stone shape',
      'number of stones',
      'stone compatibility',
      'metal',
      'metal purity',
      'metal options',
      'metal colours',
      'metal colors',
      'finish',
      'ring size',
      'engraving',
      'certification',
      'certificate'
    ]);
  }

  function parsePreviewSpecRows(html) {
    const rows = [];
    const seen = new Set();
    const allowed = previewSpecAllowedKeys();

    splitHtmlLines(html).forEach(line => {
      const match = line.match(/^([^:：]{1,80})[:：]\s*(.+)$/);
      if (!match) return;

      const label = cleanValue(match[1]);
      const value = cleanValue(match[2]);
      const key = normalizeKey(label);

      if (!label || !value || seen.has(key)) return;
      if (!allowed.has(key)) return;

      seen.add(key);
      rows.push({ label, value, key });
    });

    return rows;
  }

  function previewSpecExtraHtml(html) {
    if (!html) return '';

    const allowed = previewSpecAllowedKeys();

    const extraLines = splitHtmlLines(html).filter(line => {
      const match = line.match(/^([^:：]{1,80})[:：]\s*(.+)$/);
      if (!match) return true;

      const key = normalizeKey(match[1]);
      return !allowed.has(key);
    });

    return linesToParagraphHtml(extraLines);
  }

  function orderPreviewSpecRows(rows) {
    const preferred = [
      'gemstone type',
      'stone type',
      'main stone',
      'center stone',
      'carat weight',
      'weight',
      'shape',
      'cut',
      'color',
      'colour',
      'clarity',
      'dimensions',
      'measurement',
      'treatment',
      'origin',
      'side stones',
      'stone shape',
      'number of stones',
      'metal',
      'metal purity',
      'certification',
      'certificate'
    ];

    const byKey = {};
    const ordered = [];

    rows.forEach(row => {
      if (!byKey[row.key]) byKey[row.key] = row;
    });

    preferred.forEach(label => {
      const key = normalizeKey(label);
      if (byKey[key]) {
        ordered.push(byKey[key]);
        delete byKey[key];
      }
    });

    Object.keys(byKey).forEach(key => {
      ordered.push(byKey[key]);
    });

    return ordered;
  }

  function formatPreviewSpecificationHtml(html) {
    if (!html) return '';

    const rows = orderPreviewSpecRows(parsePreviewSpecRows(html));
    const extra = previewSpecExtraHtml(html);

    if (!rows.length) return html;

    const tableHtml =
      '<div class="grb__spec-table-clean">' +
        rows.map(row => {
          return (
            '<div class="grb__spec-list-row">' +
              '<span>' + escapeHtml(row.label) + '</span>' +
              '<strong>' + escapeHtml(row.value) + '</strong>' +
            '</div>'
          );
        }).join('') +
      '</div>';

    const extraHtml = extra
      ? '<div class="grb__spec-extra-rte">' + extra + '</div>'
      : '';

    return tableHtml + extraHtml;
  }

  function renderPreviewTabs() {
    const wrap = document.getElementById('grb-preview-tabs');
    if (!wrap) return;

    const setting = modalSetting();

    const blocks = (cfg.previewBlocks || [])
      .map(block => {
        const resolvedContent = previewBlockContent(block, setting);
        const formattedContent = isPreviewSpecificationBlock(block)
          ? formatPreviewSpecificationHtml(resolvedContent)
          : resolvedContent;

        return {
          ...block,
          resolvedContent: formattedContent
        };
      })
      .filter(block => block && block.heading && htmlToText(block.resolvedContent).trim());

    if (!blocks.length) {
      wrap.innerHTML = '';
      return;
    }

    wrap.innerHTML = blocks.map(block => {
      return (
        '<div class="grb__preview-acc">' +
          '<button class="grb__preview-acc-head" type="button" onclick="GRB.togglePreviewTab(this)" aria-expanded="false">' +
            '<span>' +
              iconSvg(block.icon) +
              escapeHtml(block.heading) +
            '</span>' +
            '<svg class="grb__acc-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<path d="M6 9l6 6 6-6"/>' +
            '</svg>' +
          '</button>' +
          '<div class="grb__preview-acc-body">' +
            block.resolvedContent +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function togglePreviewTab(btn){
    const body = btn ? btn.nextElementSibling : null;
    if(!body) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    if(expanded){
      body.classList.remove('grb__preview-acc-body--open');
      body.style.maxHeight = '0px';
      body.style.overflow = 'hidden';
    } else {
      body.classList.add('grb__preview-acc-body--open');
      body.style.maxHeight = body.scrollHeight + 'px';
      body.style.overflow = 'hidden';
      window.setTimeout(function(){
        if(body.classList.contains('grb__preview-acc-body--open')){
          body.style.maxHeight = 'none';
          body.style.overflow = 'visible';
        }
      }, 320);
    }
  }
  function truncateDescription(text,limit){ const clean=String(text||'').trim(); if(clean.length<=limit)return{short:clean,needsToggle:false}; return{short:clean.slice(0,limit).trim()+'…',needsToggle:true}; }
  function toggleModalDescription(){ state.modalDescOpen=!state.modalDescOpen; refreshModalDescription(); }
  function refreshModalDescription(){ const s=modalSetting(), desc=document.getElementById('grb-modal-desc'), btn=document.getElementById('grb-modal-read-more'); if(!desc||!btn||!s)return; const full=s.description||'Preview this design with your chosen stone.', t=truncateDescription(full,170); desc.textContent=state.modalDescOpen||!t.needsToggle?full:t.short; btn.style.display=t.needsToggle?'inline-flex':'none'; btn.textContent=state.modalDescOpen?'Show less':'Read more'; }
  function refreshModal(){ const s=modalSetting(); if(!s)return; const title=document.getElementById('grb-modal-title'), price=document.getElementById('grb-modal-price'), variant=getModalVariant(); if(title)title.textContent=s.title||'Setting preview'; if(price)price.textContent=variant?'Setting · '+money(variantPrice(variant)):'Variant unavailable'; renderModalOptions(); refreshModalDescription(); refreshModalGallery(); renderPreviewTabs(); }
  
  function resetPreviewAccordionsV63(){
    document.querySelectorAll('#grb-preview-modal .grb__preview-acc-head[aria-expanded="true"]').forEach(function(btn){
      const body = btn.nextElementSibling;
      btn.setAttribute('aria-expanded','false');
      if(body){
        body.classList.remove('grb__preview-acc-body--open');
        body.style.maxHeight = '0px';
        body.style.overflow = 'hidden';
      }
    });
  }

function refreshModalGallery(){ resetPreviewAccordionsV63(); const imgs=(imagesForSelections(modalSetting(),state.modalOptions)||[]).map(normaliseGalleryImageV55).filter(Boolean), main=document.getElementById('grb-modal-main-img'); activeModalGalleryIndexV60 = 0; if(imgs[0])renderModalMediaV65(imgs[0]); const tc=document.getElementById('grb-modal-thumbs'); if(!tc)return; tc.innerHTML=''; imgs.forEach((image,i)=>{const d=document.createElement('div'); d.className='grb__mthumb'+(i===0?' grb__mthumb--active':'')+(image.mediaType&&image.mediaType!=='image'?' grb__mthumb--video-v65':''); const img=document.createElement('img'); img.src=image.thumb||image.src; img.alt=image.altText||'Angle '+(i+1); img.loading='lazy'; d.appendChild(img); if(image.mediaType&&image.mediaType!=='image'){const play=document.createElement('span'); play.className='grb__play-v65'; play.textContent='▶'; d.appendChild(play);} d.addEventListener('mouseenter',()=>preloadImage(image.src)); d.addEventListener('touchstart',()=>preloadImage(image.src),{passive:true}); d.addEventListener('click',()=>{tc.querySelectorAll('.grb__mthumb').forEach(t=>t.classList.remove('grb__mthumb--active')); d.classList.add('grb__mthumb--active'); if(image.mediaType&&image.mediaType!=='image')renderModalMediaV65(image); else if(main)slideModalImageV60(main,image.src,i); activeModalGalleryIndexV60=i;}); tc.appendChild(d);}); }
  function lockPreviewScroll(){document.documentElement.classList.add('grb-modal-lock');document.body.classList.add('grb-modal-lock');}
  function unlockPreviewScroll(){document.documentElement.classList.remove('grb-modal-lock');document.body.classList.remove('grb-modal-lock');}
  function resetPreviewModalScroll(){const modal=document.querySelector('#grb-preview-modal .grb__modal'); if(modal) modal.scrollTop=0;}
  function openPreview(e,i){ if(e){e.preventDefault();e.stopPropagation();} restoreSettingPreviewModal(); state.modalSettingIndex=typeof i==='number'?i:state.settingIndex; const s=modalSetting(), cv=state.modalSettingIndex===state.settingIndex?getSelectedVariant():firstAvailableVariant(s); state.modalOptions=selectedOptionsFromVariant(cv); state.modalDescOpen=false; refreshModal(); document.getElementById('grb-preview-modal')?.classList.add('grb__modal-bg--open'); lockPreviewScroll(); resetPreviewModalScroll(); }
  function closePreview(){ document.getElementById('grb-preview-modal')?.classList.remove('grb__modal-bg--open'); unlockPreviewScroll(); }
  function closePreviewOutside(e){ if(e.target===document.getElementById('grb-preview-modal'))closePreview(); }
  function confirmPreview(){ state.settingIndex=state.modalSettingIndex; state.selectedOptions={...state.modalOptions}; state.selectedVariant=getModalVariant(); renderSettings(); buildThumbs(imagesForSelections(currentSetting(),state.selectedOptions)); updateSummary(); updateHeader(); updateStickyBar(); updateLuxuryStickyBar(); updateBuildContext(); repairSelectedSettingContextImage(); closePreview(); }




  function stonePreviewAccordionHtmlByHeading(headings){
    const wanted = (headings || []).map(function(item){ return normalizeKey(item); });
    const accordions = Array.from(document.querySelectorAll('#grb .grb__acc'));

    for(const acc of accordions){
      const head = acc.querySelector('.grb__acc-head span, .grb__acc-head');
      const body = acc.querySelector('.grb__acc-body');
      const heading = normalizeKey(head ? head.textContent : '');

      if(!body || !heading) continue;
      if(wanted.some(function(item){ return heading === item || heading.includes(item); })){
        const html = String(body.innerHTML || '').trim();
        if(htmlToText(html).trim()) return html;
      }
    }

    return '';
  }

  function stonePreviewDescriptionHtml(){
    const originalProductDescription = stonePreviewAccordionHtmlByHeading([
      'About this stone',
      'Description',
      'Product description'
    ]);

    if(originalProductDescription && htmlToText(originalProductDescription).trim()){
      return originalProductDescription;
    }

    const candidates = [
      cfg.productDescriptionHtml,
      cfg.productDescription,
      cfg.stoneDescriptionHtml,
      cfg.stoneDescription,
      cfg.descriptionHtml,
      cfg.description
    ].filter(Boolean);

    for(const value of candidates){
      const html = String(value || '').trim();
      if(htmlToText(html).trim()) return html;
    }

    return '';
  }

  function stonePreviewCharacteristicHtml(){
    const originalStoneFeatures = stonePreviewAccordionHtmlByHeading([
      'Stone features',
      'Characteristics',
      'Characteristic'
    ]);

    if(originalStoneFeatures && htmlToText(originalStoneFeatures).trim()){
      return originalStoneFeatures;
    }

    const candidates = [
      cfg.stoneCharacteristicsHtml,
      cfg.stoneCharacteristics,
      cfg.characteristicsHtml,
      cfg.characteristics,
      cfg.gemstoneDetailsHtml
    ].filter(Boolean);

    for(const value of candidates){
      const html = String(value || '').trim();
      if(htmlToText(html).trim()) return html;
    }

    return '';
  }

  function stonePreviewMedia(){
    const images = (cfg.stoneImages || []).map(normaliseGalleryImageV55).filter(Boolean);
    if(images.length) return images;

    const fallback = [];
    document.querySelectorAll('#grb-thumbstrip img, #grb-main-stage img, #grb .grb__mainimg img').forEach(function(img){
      const src = img.currentSrc || img.src;
      if(src) fallback.push(normaliseGalleryImageV55({mediaType:'image',src:src,thumb:src,altText:img.alt || cfg.stoneTitle || 'Selected gemstone'}));
    });

    document.querySelectorAll('#grb video').forEach(function(video){
      const sources = Array.from(video.querySelectorAll('source')).map(function(source){
        return { url: source.src || source.getAttribute('src'), mimeType: source.type || source.getAttribute('type') || '' };
      }).filter(function(source){ return source.url; });

      if(!sources.length && (video.currentSrc || video.src)){
        sources.push({ url: video.currentSrc || video.src, mimeType: '' });
      }

      if(sources.length){
        fallback.push(normaliseGalleryImageV55({
          mediaType:'video',
          src: sources[0].url,
          thumb: video.poster || (cfg.stoneImages && cfg.stoneImages[0] && (cfg.stoneImages[0].thumb || cfg.stoneImages[0].src)) || '',
          altText: cfg.stoneTitle || 'Selected gemstone video',
          sources: sources
        }));
      }
    });

    const seen = new Set();
    return fallback.filter(function(item){
      if(!item || !item.src || seen.has(item.mediaType + item.src)) return false;
      seen.add(item.mediaType + item.src);
      return true;
    });
  }

  function restoreSettingPreviewModal(){
    const modal = document.getElementById('grb-preview-modal');
    if(modal) modal.removeAttribute('data-grb-preview-mode');

    const options = document.getElementById('grb-modal-options');
    if(options) options.style.display = '';

    const readMore = document.getElementById('grb-modal-read-more');
    if(readMore) readMore.style.display = '';

    const modalNote = document.querySelector('#grb-preview-modal .grb__modal-note');
    if(modalNote){
      modalNote.style.display = '';
      modalNote.removeAttribute('aria-hidden');
    }

    document.querySelectorAll('#grb-preview-modal [onclick*="GRB.confirmPreview"], #grb-preview-modal [data-grb-confirm-preview]').forEach(function(btn){
      btn.style.display = '';
      btn.removeAttribute('aria-hidden');
    });
  }

  function renderStonePreviewDescription(){
    const desc = document.getElementById('grb-modal-desc');
    const btn = document.getElementById('grb-modal-read-more');
    if(!desc) return;

    const description = stonePreviewDescriptionHtml();
    if(description){
      desc.innerHTML = description;
      desc.style.display = '';
    } else {
      desc.innerHTML = '';
      desc.style.display = 'none';
    }

    if(btn) btn.style.display = 'none';
  }

  function renderStonePreviewTabs(){
    const wrap = document.getElementById('grb-preview-tabs');
    if(!wrap) return;

    const characteristic = stonePreviewCharacteristicHtml();
    const blocks = [];

    if(characteristic && htmlToText(characteristic).trim()){
      blocks.push({
        icon: 'diamond',
        heading: 'Characteristic',
        content: characteristic
      });
    }

    (cfg.previewBlocks || []).forEach(function(block){
      const heading = String((block && block.heading) || '').toLowerCase();
      if(!block || !block.heading || !block.content) return;
      if(heading.includes('consult') || heading.includes('advisor')){
        blocks.push({
          icon: block.icon || 'advisor',
          heading: block.heading,
          content: block.content
        });
      }
    });

    wrap.innerHTML = blocks.map(function(block){
      return (
        '<div class="grb__preview-acc">' +
          '<button class="grb__preview-acc-head" type="button" onclick="GRB.togglePreviewTab(this)" aria-expanded="false">' +
            '<span>' +
              iconSvg(block.icon) +
              escapeHtml(block.heading) +
            '</span>' +
            '<svg class="grb__acc-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<path d="M6 9l6 6 6-6"/>' +
            '</svg>' +
          '</button>' +
          '<div class="grb__preview-acc-body">' +
            block.content +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function renderStonePreviewGallery(){
    resetPreviewAccordionsV63();

    const media = stonePreviewMedia();
    const main = document.getElementById('grb-modal-main-img');
    const thumbs = document.getElementById('grb-modal-thumbs');

    activeModalGalleryIndexV60 = 0;

    if(media[0]) renderModalMediaV65(media[0]);
    if(!thumbs) return;

    thumbs.innerHTML = '';

    media.forEach(function(item, i){
      const thumb = document.createElement('div');
      thumb.className = 'grb__mthumb' + (i === 0 ? ' grb__mthumb--active' : '') + (item.mediaType && item.mediaType !== 'image' ? ' grb__mthumb--video-v65' : '');

      const img = document.createElement('img');
      img.src = item.thumb || item.src;
      img.alt = item.altText || 'Gemstone view ' + (i + 1);
      img.loading = 'lazy';
      thumb.appendChild(img);

      if(item.mediaType && item.mediaType !== 'image'){
        const play = document.createElement('span');
        play.className = 'grb__play-v65';
        play.textContent = '▶';
        thumb.appendChild(play);
      }

      thumb.addEventListener('mouseenter', function(){ preloadImage(item.src); });
      thumb.addEventListener('touchstart', function(){ preloadImage(item.src); }, { passive: true });
      thumb.addEventListener('click', function(){
        thumbs.querySelectorAll('.grb__mthumb').forEach(function(t){ t.classList.remove('grb__mthumb--active'); });
        thumb.classList.add('grb__mthumb--active');
        activeModalGalleryIndexV60 = i;

        if(item.mediaType && item.mediaType !== 'image'){
          renderModalMediaV65(item);
        } else if(main) {
          renderModalMediaV65(item);
        }
      });

      thumbs.appendChild(thumb);
    });
  }

  function refreshStonePreview(){
    const details = getStoneDetails();
    const title = document.getElementById('grb-modal-title');
    const price = document.getElementById('grb-modal-price');
    const options = document.getElementById('grb-modal-options');
    const modal = document.getElementById('grb-preview-modal');

    if(modal) modal.setAttribute('data-grb-preview-mode', 'stone');
    if(title) title.textContent = details.title || cfg.stoneTitle || cfg.productTitle || 'Selected gemstone';
    if(price) price.textContent = 'Loose stone · ' + money(cents(cfg.stonePrice));

    if(options) options.style.display = 'none';

    const modalNote = document.querySelector('#grb-preview-modal .grb__modal-note');
    if(modalNote){
      modalNote.style.display = 'none';
      modalNote.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('#grb-preview-modal [onclick*="GRB.confirmPreview"], #grb-preview-modal [data-grb-confirm-preview]').forEach(function(btn){
      btn.style.display = 'none';
      btn.setAttribute('aria-hidden', 'true');
    });

    renderStonePreviewDescription();
    renderStonePreviewGallery();
    renderStonePreviewTabs();
  }


  function openFinalStoneView(e){
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }

    refreshStonePreview();

    const modal = document.getElementById('grb-preview-modal');
    if(modal){
      modal.classList.add('grb__modal-bg--open');
      lockPreviewScroll();
      resetPreviewModalScroll();
    }
  }

  function openFinalSettingPreview(e){
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    if(!currentSetting || !currentSetting()) return;
    openPreview(e, state.settingIndex);
  }


  function selectedOptionEntries(){
    return Object.entries(state.selectedOptions || {}).filter(function(entry){
      return entry[0] && entry[1];
    });
  }

  function secondVariantSelection(){
    const s = currentSetting ? currentSetting() : null;
    if(!s || !Array.isArray(s.options) || s.options.length < 2) return null;

    const option = s.options[1];
    const optionName = option && option.name ? option.name : '';
    if(!optionName) return null;

    const value = (state.selectedOptions || {})[optionName];
    if(!value) return null;

    return { name: optionName, value: value };
  }

  function cleanSettingOptionText(){
    return selectedOptionEntries().map(function(entry){
      return entry[1];
    }).join(' / ');
  }

  function normaliseFinalSummary(){
    const secondCell = document.getElementById('grb-sum-side');
    const secondRow = secondCell ? secondCell.closest('.grb__commission-row') : null;
    const second = secondVariantSelection();

    if(secondRow){
      if(!second){
        secondRow.style.display = 'none';
      } else {
        secondRow.style.display = '';
        secondCell.textContent = second.name + ' — ' + second.value;

        const valueCell = secondRow.querySelector('span:last-child');
        if(valueCell) valueCell.textContent = 'Included';
      }
    }

    const settingPrice = document.getElementById('grb-sum-setting-price');
    if(settingPrice){
      settingPrice.style.whiteSpace = 'nowrap';
      settingPrice.style.wordBreak = 'normal';
      settingPrice.style.overflowWrap = 'normal';
    }
  }





  function stickyAction(){
    if(state.tab === 0){
      goTab(1);
      return;
    }

    if(state.tab === 1){
      const setting = currentSetting ? currentSetting() : null;
      if(setting) goTab(2);
      return;
    }

    const addBtn = document.getElementById('grb-cart-btn') || document.getElementById('grb-add-to-cart') || document.querySelector('[data-grb-add-to-cart]');
    if(addBtn) addBtn.click();
  }

  function updateLuxuryStickyBar(){
    const bar = document.getElementById('grb-stickybar');
    if(!bar) return;

    const img = document.getElementById('grb-sticky-img');
    const title = document.getElementById('grb-sticky-title');
    const sub = document.getElementById('grb-sticky-sub');
    const price = document.getElementById('grb-sticky-price');
    const button = document.getElementById('grb-sticky-btn');

    const setting = currentSetting ? currentSetting() : null;
    const settingTitle = setting ? setting.title : '';
    const stoneTitle = cfg.productTitle || document.querySelector('[data-grb-stone-title]')?.textContent || '';

    const finalStoneImg = document.getElementById('grb-final-stone-img')?.src;
    const finalSettingImg = document.getElementById('grb-final-setting-img')?.src;
    const contextSettingImg = document.getElementById('grb-context-setting-img')?.src;
    const stoneImg = cfg.stoneImages?.[0]?.src || '';

    let chosenImg = finalSettingImg || contextSettingImg || finalStoneImg || stoneImg;
    if(state.tab === 0) chosenImg = stoneImg || chosenImg;
    if(img && chosenImg) img.src = chosenImg;

    let mainTitle = stoneTitle || 'Your SARATTI piece';
    let subTitle = 'Selected for your bespoke build';

    if(settingTitle && state.tab >= 1){
      mainTitle = settingTitle;
      const opts = typeof cleanSettingOptionText === 'function' ? cleanSettingOptionText() : '';
      subTitle = opts || 'Selected setting';
      if(stoneTitle && state.tab === 2){
        subTitle = stoneTitle + (opts ? ' · ' + opts : '');
      }
    }

    if(title) title.textContent = mainTitle;
    if(sub) sub.textContent = subTitle;
    if(price){
      const value = typeof totalPrice === 'function' ? totalPrice() : 0;
      price.textContent = typeof money === 'function' ? money(value) : value;
    }

    if(button){
      if(state.tab === 0){
        button.textContent = 'Choose setting';
      } else if(state.tab === 1){
        button.textContent = setting ? 'Continue' : 'Choose setting';
      } else {
        button.textContent = state.size ? 'Add to cart' : 'Select size';
      }
    }

    bar.classList.toggle('grb__stickybar--final', state.tab === 2);
  }

  function updateStickyHeaderState(){
    const root = document.querySelector('.grb');
    const topbar = document.querySelector('.grb__topbar');
    if(!root || !topbar) return;

    if(!topbar.dataset.grbOriginalTop){
      const pageTop = window.scrollY + topbar.getBoundingClientRect().top;
      topbar.dataset.grbOriginalTop = String(pageTop);
    }

    const originalTop = parseFloat(topbar.dataset.grbOriginalTop || '0');
    const isStuck = window.scrollY > originalTop + 4;
    root.classList.toggle('grb--stuck', isStuck);
  }


  function parseProcessImageList(raw){
    return String(raw || '')
      .split('||')
      .map(function(item){ return String(item || '').trim(); })
      .filter(Boolean);
  }

  function processImages(){
    const modal = document.getElementById('grb-process-modal');

    const stoneFallback = document.getElementById('grb-final-stone-img')?.src || cfg.stoneImages?.[0]?.src || '';
    const settingFallback = selectedSettingImageUrl?.() || document.getElementById('grb-final-setting-img')?.src || document.getElementById('grb-context-setting-img')?.src || stoneFallback;

    const images = {
      stone: modal ? parseProcessImageList(modal.dataset.stoneImgs) : [],
      design: modal ? parseProcessImageList(modal.dataset.designImgs) : [],
      artisan: modal ? parseProcessImageList(modal.dataset.artisanImgs) : [],
      qc: modal ? parseProcessImageList(modal.dataset.qcImgs) : [],
      film: modal ? parseProcessImageList(modal.dataset.filmImgs) : [],
      delivery: modal ? parseProcessImageList(modal.dataset.deliveryImgs) : []
    };

    if(!images.stone.length && stoneFallback) images.stone = [stoneFallback];
    if(!images.design.length && settingFallback) images.design = [settingFallback];
    if(!images.artisan.length && settingFallback) images.artisan = [settingFallback];
    if(!images.qc.length && settingFallback) images.qc = [settingFallback];
    if(!images.film.length && settingFallback) images.film = [settingFallback];
    if(!images.delivery.length && settingFallback) images.delivery = [settingFallback];

    return images;
  }

  function stopProcessRotation(){
    if(processRotationTimer){
      clearInterval(processRotationTimer);
      processRotationTimer = null;
    }
  }

  function applyProcessImage(src){
    const img = document.getElementById('grb-process-img');
    if(!img || !src) return;
    if(img.dataset.currentSrc === src) return;
    img.style.opacity = '0';
    window.setTimeout(function(){
      img.src = src;
      img.dataset.currentSrc = src;
      img.style.opacity = '1';
    }, 140);
  }

  function startProcessRotation(type){
    stopProcessRotation();
    const imgs = processImages()[type] || [];
    processRotationType = type;
    processRotationIndex = 0;

    if(imgs.length){
      applyProcessImage(imgs[0]);
      imgs.forEach(preloadImage);
    }

    if(imgs.length <= 1) return;

    processRotationTimer = window.setInterval(function(){
      const activeImgs = processImages()[processRotationType] || [];
      if(activeImgs.length <= 1) return;
      processRotationIndex = (processRotationIndex + 1) % activeImgs.length;
      applyProcessImage(activeImgs[processRotationIndex]);
    }, 2000);
  }

  function setProcessVisual(type){
    const kicker = document.getElementById('grb-process-visual-kicker');
    const title = document.getElementById('grb-process-visual-title');

    const activeStep = document.querySelector('.grb__process-step[data-process-type="'+type+'"]') || document.querySelector('.grb__process-step');
    const activeKicker = activeStep ? activeStep.dataset.processKicker : '';
    const activeVisualTitle = activeStep ? activeStep.dataset.processVisualTitle : '';

    const fallbackCopy = {
      stone: ['STONE REVIEW', 'Where every journey begins.'],
      design: ['DESIGN', 'Drawn to the dimensions of your stone.'],
      artisan: ['HANDCRAFTING', 'Made by hand, etched in metal, set with intention.'],
      qc: ['QUALITY CONTROL', 'Held to a standard that does not bend.'],
      film: ['THE REVEAL', 'First sight, in your hand, before it travels.'],
      delivery: ['DELIVERY', 'From our atelier to your hand.']
    };

    const selected = fallbackCopy[type] || fallbackCopy.stone;

    if(kicker) kicker.textContent = activeKicker || selected[0];
    if(title) title.textContent = activeVisualTitle || selected[1];

    document.querySelectorAll('.grb__process-step').forEach(function(step){ step.classList.remove('grb__process-step--active'); });
    if(activeStep) activeStep.classList.add('grb__process-step--active');

    startProcessRotation(type);
  }


  function openProcessStep(e, type){
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    updateFinalVisuals();
    setProcessVisual(type || 'stone');
    const modal = document.getElementById('grb-process-modal');
    if(modal){
      modal.classList.add('grb__process-modal-bg--open');
      document.documentElement.classList.add('grb-process-lock');
      document.body.classList.add('grb-process-lock');
    }
  }

  function openProcessModal(e){
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    updateFinalVisuals();
    setProcessVisual('stone');
    const modal = document.getElementById('grb-process-modal');
    if(modal){
      modal.classList.add('grb__process-modal-bg--open');
      document.documentElement.classList.add('grb-process-lock');
      document.body.classList.add('grb-process-lock');
    }
  }

  function closeProcessModal(){
    const modal = document.getElementById('grb-process-modal');
    if(modal) modal.classList.remove('grb__process-modal-bg--open');
    document.documentElement.classList.remove('grb-process-lock');
    document.body.classList.remove('grb-process-lock');
  }

  function closeProcessModalOutside(e){
    if(e && e.target && e.target.id === 'grb-process-modal') closeProcessModal();
  }

  function updateFinalVisuals(){
    const s = currentSetting ? currentSetting() : null;
    const settingImg = document.getElementById('grb-final-setting-img');
    const settingTitle = document.getElementById('grb-final-setting-title');
    const settingOptions = document.getElementById('grb-final-setting-options');

    if(!settingImg || !settingTitle || !settingOptions) return;

    if(!s){
      settingImg.removeAttribute('src');
      settingImg.style.opacity = '0';
      settingTitle.textContent = 'Select a setting';
      settingOptions.textContent = '';
      return;
    }

    let imgSrc = '';

    try {
      const selectedVariant = variantForOptions ? variantForOptions(s, state.selectedOptions || {}) : null;
      if(selectedVariant && selectedVariant.image) imgSrc = selectedVariant.image;
      if(!imgSrc && selectedVariant && selectedVariant.featuredImage) imgSrc = selectedVariant.featuredImage;
    } catch(e) {}

    try {
      const imgs = imagesForSelections(s, state.selectedOptions || {});
      const first = imgs && imgs[0];
      if(!imgSrc && first) imgSrc = first.src || first.thumb || '';
    } catch(e) {}

    if(!imgSrc && s.featuredImage) imgSrc = s.featuredImage;

    if(imgSrc){
      settingImg.src = imgSrc;
      settingImg.alt = s.title || 'Selected setting';
      settingImg.style.opacity = '1';
    } else {
      settingImg.removeAttribute('src');
      settingImg.style.opacity = '0';
    }

    settingTitle.textContent = s.title || 'Selected setting';

    const opts = cleanSettingOptionText();
    settingOptions.textContent = opts || '';
    normaliseFinalSummary();
  }


  function syncFinalVisualsSoon(){
    window.requestAnimationFrame(function(){
      updateFinalVisuals();
      setTimeout(updateFinalVisuals, 60);
    });
  }



  function validImageUrl(src){
    src = String(src || '').trim();
    if(!src) return false;
    if(src === 'null' || src === 'undefined') return false;
    if(src.indexOf('no-image') > -1) return false;
    return true;
  }

  function selectedSettingImageUrl(){
    const s = currentSetting ? currentSetting() : null;
    if(!s) return '';

    const candidates = [
      s.featured_image,
      s.featuredImage,
      s.image,
      s.img,
      s.media && s.media[0] && (s.media[0].src || s.media[0].preview_image?.src),
      s.images && s.images[0] && (s.images[0].src || s.images[0])
    ];

    for(const c of candidates){
      if(typeof c === 'string' && validImageUrl(c)) return c;
      if(c && typeof c === 'object'){
        const src = c.src || c.url || c.originalSrc || c.preview_image?.src;
        if(validImageUrl(src)) return src;
      }
    }

    const selectedCard = document.querySelector('.grb__setting-card--selected img, .grb__setting-card.is-selected img, .grb__setting-card.active img');
    if(selectedCard && validImageUrl(selectedCard.currentSrc || selectedCard.src)) return selectedCard.currentSrc || selectedCard.src;

    return '';
  }

  function repairSelectedSettingContextImage(){
    const img = document.getElementById('grb-context-setting-img');
    if(!img) return;

    const s = currentSetting ? currentSetting() : null;
    const src = selectedSettingImageUrl();

    if(s && validImageUrl(src)){
      img.src = src;
      img.removeAttribute('hidden');
      img.style.display = '';
      img.closest('.grb__context-img, .grb__selected-img, .grb__context-thumb')?.classList.remove('grb__img-missing');
    } else {
      img.removeAttribute('src');
      img.setAttribute('hidden', 'hidden');
      img.style.display = 'none';
      img.closest('.grb__context-img, .grb__selected-img, .grb__context-thumb')?.classList.add('grb__img-missing');
    }
  }

  function updateBuildContext(){ const s=currentSetting(), name=document.getElementById('grb-context-setting'), img=document.getElementById('grb-context-setting-img'), card=document.getElementById('grb-context-setting-card'); if(!name||!img||!card)return; if(!s){name.textContent='Choose a setting below'; img.removeAttribute('src'); card.classList.add('grb__context-card--empty'); return;} const imgs=imagesForSelections(s,state.selectedOptions), first=imgs&&imgs[0]; name.textContent=s.title||'Selected setting'; img.src=(first&&(first.thumb||first.src))||s.featuredImage||''; img.alt=s.title||'Selected setting'; card.classList.remove('grb__context-card--empty'); }
  function metalValue(){ const k=Object.keys(state.selectedOptions||{}).find(x=>normalizeKey(x).includes('metal')||normalizeKey(x).includes('material')); return k?state.selectedOptions[k]:''; }
  function sideStoneValue(){ const k=Object.keys(state.selectedOptions||{}).find(x=>normalizeKey(x).includes('side')||normalizeKey(x).includes('stone')||normalizeKey(x).includes('diamond')); return k?state.selectedOptions[k]:''; }
  function updateSummary(){ const s=currentSetting(), v=getSelectedVariant(), setPrice=variantPrice(v), total=cents(cfg.stonePrice)+setPrice, opts=Object.values(state.selectedOptions||{}).filter(Boolean).join(' / '); const setEl=document.getElementById('grb-sum-setting'); if(setEl)setEl.textContent=s?'Setting — '+s.title+(opts?' ('+opts+')':''):'Setting — Not selected'; const setP=document.getElementById('grb-sum-setting-price'); if(setP)setP.textContent=money(setPrice); const side=document.getElementById('grb-sum-side'); if(side){ const sideRow=side.closest('.grb__commission-row'); const second=secondVariantSelection(); if(!second){ if(sideRow)sideRow.style.display='none'; } else { if(sideRow)sideRow.style.display=''; side.textContent=second.name+' — '+second.value; const valueCell=sideRow.querySelector('span:last-child'); if(valueCell)valueCell.textContent='Included'; } } const totalEl=document.getElementById('grb-sum-total'); if(totalEl)totalEl.textContent=money(total); normaliseFinalSummary(); updateCartButton(); }

  function showRingSizeRequired(){
    const sizeField = document.getElementById('grb-size-select') || document.getElementById('grb-ring-size') || document.getElementById('grb-size') || document.querySelector('#grb select[name*="size" i], #grb input[name*="size" i]');
    if(!sizeField) return;

    sizeField.classList.add('grb__field--error');
    sizeField.setAttribute('aria-invalid','true');

    const holder = sizeField.closest('.grb__config-row') || sizeField.closest('.grb__field') || sizeField.parentElement;
    let msg = document.getElementById('grb-size-required-message');

    if(!msg){
      msg = document.createElement('div');
      msg.id = 'grb-size-required-message';
      msg.className = 'grb__inline-error';
      msg.setAttribute('role','alert');
      msg.textContent = 'Please select your ring size before adding your ring to cart.';
      if(holder) holder.appendChild(msg);
    }

    try{
      (holder || sizeField).scrollIntoView({behavior:'smooth', block:'center'});
    }catch(e){
      try{ (holder || sizeField).scrollIntoView(); }catch(_) {}
    }

    window.setTimeout(function(){
      try{ sizeField.focus({preventScroll:true}); }catch(e){ try{ sizeField.focus(); }catch(_){} }
    }, 220);
  }

  function clearRingSizeRequired(){
    const sizeField = document.getElementById('grb-ring-size') || document.getElementById('grb-size') || document.querySelector('#grb select[name*="size" i], #grb input[name*="size" i]');
    if(sizeField){
      sizeField.classList.remove('grb__field--error');
      sizeField.removeAttribute('aria-invalid');
    }
    const msg = document.getElementById('grb-size-required-message');
    if(msg) msg.remove();
  }

  function updateCartButton(){ const btn=document.getElementById('grb-cart-btn'), s=currentSetting(), v=getSelectedVariant(); if(!btn)return; if(!s){btn.textContent='Select a setting to continue'; btn.disabled=true; return;} if(!v||!v.available){btn.textContent='This variant is unavailable'; btn.disabled=true; return;} if(!state.size){btn.textContent='Select a ring size to continue'; btn.disabled=false; return;} btn.textContent='Add both to cart — '+money(totalPrice()); btn.disabled=false; }
  function updateHeader(){ const lbl=document.getElementById('grb-header-label'), prc=document.getElementById('grb-header-price'), s=currentSetting(); if(lbl)lbl.textContent=['Gemstone','Build a piece','Finalise'][state.tab]||'Gemstone'; if(prc)prc.textContent=money(state.tab===0?cents(cfg.stonePrice):totalPrice()); const ts1=document.getElementById('grb-ts-1'); if(ts1)ts1.textContent=s?s.title+(metalValue()?' · '+metalValue():''):'Select a setting'; const ts2=document.getElementById('grb-ts-2'); if(ts2)ts2.textContent=state.size?'Size '+state.size+' · Order':'Size · Engraving · Order'; }
  function updateStickyBar(){ const s=currentSetting(), prc=document.getElementById('grb-sbar-price'), sub=document.getElementById('grb-sbar-sub'), btn=document.getElementById('grb-sbar-btn'), img=document.getElementById('grb-sbar-img'); if(prc)prc.textContent=money(state.tab===0?cents(cfg.stonePrice):totalPrice()); if(sub){if(state.tab===0)sub.textContent='Loose stone'; else if(s)sub.textContent=s.title+(metalValue()?' · '+metalValue():'')+(state.size?' · Size '+state.size:''); else sub.textContent='Select a setting';} if(img&&state.tab>0){const images=imagesForSelections(s,state.selectedOptions); if(images[0])img.src=images[0].thumb||images[0].src;} else if(img&&cfg.stoneImages&&cfg.stoneImages[0])img.src=cfg.stoneImages[0].thumb||cfg.stoneImages[0].src; if(btn){if(state.tab===0){btn.textContent='Build a piece →'; btn.onclick=()=>goTab(1);} else if(state.tab===1){btn.textContent='Continue →'; btn.onclick=()=>goTab(2);} else {btn.textContent=state.size?'Add to cart':'Select size'; btn.onclick=addToCart;}} }
    updateFinalVisuals();
  function pickSize(v){ state.size=v||''; if(state.size) clearRingSizeRequired(); const el=document.getElementById('grb-sum-size'); if(el){el.textContent=state.size||'Not selected'; el.classList.toggle('grb__sum-placeholder',!state.size);} updateCartButton(); updateStickyBar(); updateLuxuryStickyBar(); }
  function pickEngraving(v){ state.engraving=v||''; const count=document.getElementById('grb-char-count'); if(count){count.textContent=state.engraving.length+' / 12'; count.classList.toggle('grb__char-count--warn',state.engraving.length>=10);} const row=document.getElementById('grb-sum-eng-row'), eng=document.getElementById('grb-sum-eng'); if(row&&eng){row.style.display=state.engraving.trim()?'flex':'none'; eng.textContent=state.engraving.trim()?('"'+state.engraving.trim()+'"'):'';} }
  function toggleAcc(head){ const body=head.nextElementSibling, expanded=head.getAttribute('aria-expanded')==='true'; head.setAttribute('aria-expanded',expanded?'false':'true'); body.classList.toggle('grb__acc-body--open'); }
  function closeDrawer(id){ document.getElementById(id)?.classList.remove('grb__drawer-bg--open'); }
  function closeDrawerOutside(e,id){ if(e.target===document.getElementById(id))closeDrawer(id); }
  function openSizeGuide(){ document.getElementById('grb-size-drawer')?.classList.add('grb__drawer-bg--open'); }
  function addLooseToCart(){ if(!cfg.stoneVariantId)return; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:cfg.stoneVariantId,quantity:1})}).then(r=>r.json()).then(()=>{window.location.href=cfg.cartUrl||'/cart';}).catch(e=>{console.error('SARATTI Builder cart error:',e); alert('Something went wrong. Please try again.');}); }
  function addToCart(){
    const s=currentSetting(), v=getSelectedVariant();

    if(!s || !v){
      updateCartButton();
      return;
    }

    if(!state.size){
      updateCartButton();
      showRingSizeRequired();
      return;
    }

    const bundleId='saratti-build-'+Date.now(), details=getStoneDetails(), optionProps={};
    Object.keys(state.selectedOptions||{}).forEach(name=>optionProps[name]=state.selectedOptions[name]);

    const stoneName = cfg.productTitle || cfg.stoneTitle || details.title || '';
    const settingName = s.title || 'Selected setting';
    const metalText = metalValue() || optionProps.Metal || optionProps['Metal Color'] || optionProps['Metal type'] || '';
    const pieceType = 'Custom Design Bundle';

    const sharedBundleProps = {
      'Piece Type': pieceType,
      'Style': settingName,
      'Metal': metalText,
      'Stone': stoneName,
      'SKU': cfg.stoneSku || '',
      '_SARATTI Build ID': bundleId,
      '_bundle': bundleId
    };

    const items=[
      {
        id:cfg.stoneVariantId,
        quantity:1,
        properties:{
          ...sharedBundleProps,
          '_bundle_role':'stone',
          '_Bundle role':'Gemstone',
          '_center_stone_name': stoneName,
          '_center_stone_carat_weight': details.weight || '',
          '_center_stone_shape': details.shape || '',
          '_center_stone_dimensions': details.dimensions || '',
          '_center_stone_origin': details.origin || '',
          '_center_stone_certificate': details.certificate || '',
          '_setting_name': settingName,
          '_setting_metal': metalText,
          '_ring_size': state.size
        }
      },
      {
        id:v.id,
        quantity:1,
        properties:{
          ...sharedBundleProps,
          '_bundle_role':'setting',
          '_Bundle role':'Setting',
          '_center_stone_name': stoneName,
          '_center_stone_carat_weight': details.weight || '',
          '_center_stone_shape': details.shape || '',
          '_center_stone_dimensions': details.dimensions || '',
          '_center_stone_origin': details.origin || '',
          '_center_stone_certificate': details.certificate || '',
          '_setting_name': settingName,
          '_setting_variant': v.title || '',
          '_setting_metal': metalText,
          '_ring_size': state.size,
          '_engraving': state.engraving.trim() || '',
          '_ring_sizer_requested': state.sizerRequested ? 'Yes' : '',
          'Ring size': state.size,
          ...(state.engraving.trim()?{'Engraving':state.engraving.trim()}:{}),
          ...(state.sizerRequested?{'Ring sizer requested':'Yes'}:{})
        }
      }
    ];

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items})
    })
    .then(r=>r.json())
    .then(data=>{
      if(data&&data.status){
        console.error('SARATTI Builder cart error:',data);
        alert(data.description||'Something went wrong. Please try again.');
      }else{
        window.location.href=cfg.cartUrl||'/cart';
      }
    })
    .catch(e=>{
      console.error('SARATTI Builder cart error:',e);
      alert('Something went wrong. Please try again.');
    });
  }

    function requestConsultation(){ const s=currentSetting(), text=encodeURIComponent('Hello SARATTI, I would like help building a piece with this stone: '+(cfg.stoneTitle||'')+(s?' and the '+s.title+' setting.':'.')); window.location.href='/pages/contact?message='+text; }
  function initStickyBar(){ const bar=document.getElementById('grb-stickybar'), journey=document.getElementById('grb-journey'); if(!bar)return; window.addEventListener('scroll',()=>{const scrolled=window.scrollY>100, journeyTop=journey?journey.getBoundingClientRect().top:Infinity, nearJourney=journeyTop<80; bar.classList.toggle('grb__stickybar--visible',scrolled&&!nearJourney); bar.setAttribute('aria-hidden',scrolled&&!nearJourney?'false':'true');},{passive:true}); }
  function init(){ if(!document.getElementById('grb'))return; if(cfg.settings&&cfg.settings.length)initialiseSettingSelection(0); renderStoneSpecs(); renderSettings(); preloadAllBuilderImages(); buildThumbs(cfg.stoneImages||[]); const cb=document.getElementById('grb-sizer-cb'); if(cb)cb.addEventListener('change',e=>{state.sizerRequested=!!e.target.checked;}); document.addEventListener('keydown',e=>{if(e.key==='Escape'){closePreview(); ['grb-guide-drawer','grb-size-drawer'].forEach(closeDrawer);}}); initStickyBar(); updateSummary(); updateHeader(); updateStickyBar(); updateLuxuryStickyBar(); updateBuildContext(); repairSelectedSettingContextImage(); }

  document.addEventListener('click', function(e){
    if(!e.target) return;
    if(e.target.closest('[onclick*="GRB.selectSetting"], [onclick*="GRB.modalPickOption"], [onclick*="GRB.pickMetal"], [onclick*="GRB.pickSide"], [onclick*="GRB.goTab"]')){
      setTimeout(updateFinalVisuals, 80);
      setTimeout(updateFinalVisuals, 220);
    }
  }, true);


  document.addEventListener('click', function(){
    setTimeout(normaliseFinalSummary, 80);
    setTimeout(normaliseFinalSummary, 240);
  }, true);


  updateStickyHeaderState();
  window.addEventListener('scroll', updateStickyHeaderState, { passive: true });
  window.addEventListener('resize', function(){
    const topbar = document.querySelector('.grb__topbar');
    if(topbar) delete topbar.dataset.grbOriginalTop;
    updateStickyHeaderState();
  }, { passive: true });


  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeProcessModal();
  });

  window.setTimeout(updateLuxuryStickyBar, 80); window.setTimeout(initServiceCarouselV49, 140); window.setTimeout(repairSelectedSettingContextImage, 100);


  document.addEventListener('click', function(){
    window.setTimeout(repairSelectedSettingContextImage, 80);
    window.setTimeout(repairSelectedSettingContextImage, 180);
  }, true);


  function currentBuildSummaryV49(){
    const setting = currentSetting ? currentSetting() : null;
    const stoneTitle = cfg.productTitle || document.title || 'Selected gemstone';
    const settingTitle = setting ? setting.title : '';
    const metal = typeof metalValue === 'function' ? metalValue() : '';
    const size = state.size || '';
    const engraving = document.getElementById('grb-engraving')?.value || '';
    const total = typeof totalPrice === 'function' && typeof money === 'function' ? money(totalPrice()) : '';
    return [
      'Gemstone: ' + stoneTitle,
      settingTitle ? 'Selected setting: ' + settingTitle : '',
      metal ? 'Metal: ' + metal : '',
      size ? 'Ring size: ' + size : '',
      engraving ? 'Engraving: ' + engraving : '',
      total ? 'Estimated total: ' + total : '',
      'Page: ' + window.location.href
    ].filter(Boolean).join('\\n');
  }

  function hydrateSoftModalV49(kind){
    const summary = currentBuildSummaryV49();
    ['grb-hint-build-details-v49','grb-custom-build-details-v49'].forEach(function(id){
      const input = document.getElementById(id);
      if(input) input.value = summary;
    });

    const setting = currentSetting ? currentSetting() : null;
    const settingImg = typeof selectedSettingImageUrl === 'function' ? selectedSettingImageUrl() : '';
    const stoneImg = cfg.stoneImages?.[0]?.src || document.querySelector('.grb__thumb img, .grb__gallery img')?.src || '';
    const imgSrc = kind === 'custom' ? stoneImg : (settingImg || stoneImg);

    [['grb-hint-product-img-v49', imgSrc], ['grb-custom-product-img-v49', stoneImg || imgSrc]].forEach(function(pair){
      const img = document.getElementById(pair[0]);
      if(img && pair[1]) img.src = pair[1];
    });

    const hintTitle = document.getElementById('grb-hint-product-title-v49');
    if(hintTitle) hintTitle.textContent = kind === 'custom' ? (cfg.productTitle || 'Selected gemstone') : (setting?.title || cfg.productTitle || 'Item of interest');

    const hintSub = document.getElementById('grb-hint-product-sub-v49');
    if(hintSub && typeof totalPrice === 'function' && typeof money === 'function') hintSub.textContent = money(totalPrice());

    const customTitle = document.getElementById('grb-custom-product-title-v49');
    if(customTitle) customTitle.textContent = cfg.productTitle || 'Selected gemstone';
    const customLink = document.getElementById('grb-custom-product-link-v55');
    if(customLink){
      customLink.textContent = cfg.productTitle || cfg.stoneTitle || 'Selected gemstone';
      customLink.href = cfg.productUrl || window.location.pathname;
    }
  }

  function openSoftModalV49(id, kind){
    const modal = document.getElementById(id);
    if(!modal) return;
    hydrateSoftModalV49(kind || '');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('grb-modal-lock');
    document.body.classList.add('grb-modal-lock');
  }

  function openHintModal(e){
    if(e) e.preventDefault();
    openSoftModalV49('grb-hint-modal-v49', 'hint');
  }

  function openCustomDesignModal(e){
    if(e) e.preventDefault();
    openSoftModalV49('grb-custom-design-modal-v49', 'custom');
  }

  function openPrivateInquiry(e){
    if(e) e.preventDefault();
    const existingTriggers = [
      '[data-open-private-enquiry]',
      '[data-open-private-inquiry]',
      '[data-open-enquiry]',
      '[data-enquiry-trigger]',
      '.product__enquiry-button',
      '.enquiry-button',
      '.private-enquiry-button',
      'button[name="private-enquiry"]'
    ];

    for(const selector of existingTriggers){
      const trigger = document.querySelector(selector);
      if(trigger && !trigger.classList.contains('grb__link-action-v49') && !trigger.classList.contains('grb__private-inquiry-final-v49')){
        trigger.click();
        return;
      }
    }

    openSoftModalV49('grb-custom-design-modal-v49', 'custom');
  }

  function closeSoftModals(e){
    if(e) e.preventDefault();
    document.querySelectorAll('.grb__soft-modal-v49').forEach(function(modal){
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
    });
    document.documentElement.classList.remove('grb-modal-lock');
    document.body.classList.remove('grb-modal-lock');
  }

  function initServiceCarouselV49(){
    const slider = document.getElementById('grb-service-carousel-v49');
    if(!slider || slider.dataset.ready === 'true') return;
    slider.dataset.ready = 'true';

    const prev = document.getElementById('grb-service-prev-v57');
    const next = document.getElementById('grb-service-next-v57');
    const items = Array.from(slider.querySelectorAll('.grb__service-card-v49'));
    if(!items.length) return;

    let page = 0;
    let paused = false;

    function pageWidth(){
      return Math.max(240, slider.clientWidth || 320);
    }

    function maxPage(){
      const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
      return Math.max(0, Math.ceil(maxLeft / pageWidth()));
    }

    function updateArrowState(){
      const max = maxPage();
      if(prev) prev.disabled = page <= 0;
      if(next) next.disabled = page >= max;
    }

    

  function initVideoMediaV64(){
    document.querySelectorAll('#grb video').forEach(function(video){
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.preload = video.preload || 'metadata';
      video.controls = true;
    });
  }

function setActiveByScroll(){
      const centre = slider.scrollLeft + (slider.clientWidth / 2);
      let closest = 0;
      let distance = Infinity;

      items.forEach(function(item, i){
        const mid = item.offsetLeft + (item.offsetWidth / 2);
        const d = Math.abs(mid - centre);
        if(d < distance){
          distance = d;
          closest = i;
        }
      });

      items.forEach(function(item, i){
        item.classList.toggle('is-active', i === closest);
      });

      page = Math.max(0, Math.min(maxPage(), Math.round(slider.scrollLeft / pageWidth())));
      updateArrowState();
    }

    function goToPage(nextPage, smooth){
      const max = maxPage();
      page = Math.max(0, Math.min(max, nextPage));
      slider.scrollTo({ left: page * pageWidth(), behavior: smooth === false ? 'auto' : 'smooth' });
      window.setTimeout(setActiveByScroll, smooth === false ? 20 : 420);
    }

    function goNextPage(){
      if(paused || document.hidden) return;
      const max = maxPage();
      goToPage(page >= max ? 0 : page + 1, true);
    }

    if(prev){
      prev.addEventListener('click', function(){
        paused = true;
        goToPage(page - 1, true);
        window.setTimeout(function(){ paused = false; }, 1200);
      });
    }

    if(next){
      next.addEventListener('click', function(){
        paused = true;
        goToPage(page + 1, true);
        window.setTimeout(function(){ paused = false; }, 1200);
      });
    }

    slider.addEventListener('scroll', function(){
      window.clearTimeout(slider._grbScrollTimer);
      slider._grbScrollTimer = window.setTimeout(setActiveByScroll, 90);
    }, { passive: true });

    slider.addEventListener('mouseenter', function(){ paused = true; });
    slider.addEventListener('mouseleave', function(){ paused = false; });
    slider.addEventListener('touchstart', function(){ paused = true; }, { passive: true });
    slider.addEventListener('touchend', function(){
      window.setTimeout(function(){ paused = false; }, 1200);
    }, { passive: true });

    window.addEventListener('resize', function(){
      goToPage(Math.min(page, maxPage()), false);
    }, { passive: true });

    setActiveByScroll();
    window.setInterval(goNextPage, 2000);
  }




  function externalVideoUrlV65(media){
    if(!media || !media.externalId) return '';
    const host = String(media.host || '').toLowerCase();
    if(host.indexOf('youtube') > -1) return 'https://www.youtube.com/embed/' + encodeURIComponent(media.externalId) + '?rel=0&playsinline=1';
    if(host.indexOf('vimeo') > -1) return 'https://player.vimeo.com/video/' + encodeURIComponent(media.externalId);
    return '';
  }

  function cleanupMediaStageV65(stage){
    if(!stage) return;
    stage.querySelectorAll('.grb__video-media-v65, .grb__external-media-v65, video.grb__video-media-v65, iframe.grb__external-media-v65').forEach(function(el){ el.remove(); });
    stage.classList.remove('grb__mainimg--video-active','grb__mainimg--external-video-active');
  }

  function buildVideoElV65(media){
    const video = document.createElement('video');
    video.className = 'grb__video-media-v65';
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('playsinline','');
    video.setAttribute('webkit-playsinline','');
    video.preload = 'metadata';
    if(media && media.thumb) video.poster = media.thumb;
    (media.sources || []).forEach(function(source){
      if(!source || !source.url) return;
      const s = document.createElement('source');
      s.src = source.url;
      if(source.mimeType) s.type = source.mimeType;
      video.appendChild(s);
    });
    return video;
  }

  function renderMainMediaV65(media){
    const stage = document.getElementById('grb-main-stage') || document.querySelector('.grb__mainimg');
    const img = document.getElementById('grb-main-img');
    if(!stage || !media) return false;

    cleanupMediaStageV65(stage);

    if(media.mediaType === 'video' && media.sources && media.sources.length){
      stage.classList.add('grb__mainimg--video-active');
      if(img) img.style.setProperty('display','none','important');
      const video = buildVideoElV65(media);
      stage.appendChild(video);
      try { video.load(); } catch(e) {}
      return true;
    }

    if(media.mediaType === 'external_video'){
      const url = externalVideoUrlV65(media);
      if(url){
        stage.classList.add('grb__mainimg--external-video-active');
        if(img) img.style.setProperty('display','none','important');
        const iframe = document.createElement('iframe');
        iframe.className = 'grb__external-media-v65';
        iframe.src = url;
        iframe.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen','');
        stage.appendChild(iframe);
        return true;
      }
    }

    if(img){
      img.style.removeProperty('display');
      img.loading = 'eager';
      img.decoding = 'async';
      if(media.src) img.src = media.src;
      if(media.altText) img.alt = media.altText;
    }
    return false;
  }

  function renderModalMediaV65(media){
    const stage = document.querySelector('#grb-preview-modal .grb__modal-main');
    const img = document.getElementById('grb-modal-main-img');
    if(!stage || !media) return false;

    cleanupMediaStageV65(stage);

    if(media.mediaType === 'video' && media.sources && media.sources.length){
      stage.classList.add('grb__mainimg--video-active');
      if(img) img.style.setProperty('display','none','important');
      const video = buildVideoElV65(media);
      stage.appendChild(video);
      try { video.load(); } catch(e) {}
      return true;
    }

    if(media.mediaType === 'external_video'){
      const url = externalVideoUrlV65(media);
      if(url){
        stage.classList.add('grb__mainimg--external-video-active');
        if(img) img.style.setProperty('display','none','important');
        const iframe = document.createElement('iframe');
        iframe.className = 'grb__external-media-v65';
        iframe.src = url;
        iframe.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen','');
        stage.appendChild(iframe);
        return true;
      }
    }

    if(img){
      img.style.removeProperty('display');
      if(media.src) img.src = media.src;
      if(media.altText) img.alt = media.altText;
    }
    return false;
  }


  /* SARATTI v55 — gallery counter + swipe + safe image switching */
  let activeGalleryImagesV55 = [];
  let activeGalleryIndexV55 = 0;

  function normaliseGalleryImageV55(image){
    if(!image) return null;
    if(typeof image === 'string') return { mediaType: 'image', src: image, thumb: image, altText: 'Gallery image' };
    if(!image.src && !image.sources) return null;
    return {
      mediaType: image.mediaType || image.type || 'image',
      src: image.src || image.thumb || '',
      thumb: image.thumb || image.src || '',
      altText: image.altText || image.alt || 'Gallery image',
      sources: image.sources || [],
      host: image.host || '',
      externalId: image.externalId || image.external_id || ''
    };
  }

  function updateGalleryCounterV55(){
    const counter = document.getElementById('grb-image-counter');
    if(!counter) return;
    const total = Math.max(activeGalleryImagesV55.length, 1);
    const index = Math.min(Math.max(activeGalleryIndexV55, 0), total - 1);
    counter.textContent = (index + 1) + ' / ' + total;
    counter.style.display = total > 1 ? '' : 'none';
  }

  function setMainImgV55(src, index){
    const el = document.getElementById('grb-main-img');
    if(!src) return;
    if(typeof index === 'number') activeGalleryIndexV55 = index;
    const media = (typeof index === 'number' && activeGalleryImagesV55[index]) ? activeGalleryImagesV55[index] : activeGalleryImagesV55.find(function(item){ return item && item.src === src; });
    if(media && renderMainMediaV65(media)){
      updateGalleryCounterV55();
      return;
    }
    if(!el) return;
    el.style.display = '';
    el.src = src;
    updateGalleryCounterV55();
  }

  function setMainImgSlideV58(src, index, direction){
    const el = document.getElementById('grb-main-img');
    const stage = document.getElementById('grb-main-stage') || document.querySelector('.grb__mainimg');
    if(!el || !src) return;

    const media = (typeof index === 'number' && activeGalleryImagesV55[index]) ? activeGalleryImagesV55[index] : activeGalleryImagesV55.find(function(item){ return item && item.src === src; });
    if(media && media.mediaType && media.mediaType !== 'image'){
      if(typeof index === 'number') activeGalleryIndexV55 = index;
      renderMainMediaV65(media);
      updateGalleryCounterV55();
      return;
    }
    renderMainMediaV65({mediaType:'image',src:src});
    const current = (el.currentSrc || el.src || '').split('?')[0];
    const next = String(src || '').split('?')[0];
    if(current && next && current === next){
      if(typeof index === 'number') activeGalleryIndexV55 = index;
      updateGalleryCounterV55();
      return;
    }

    const dir = direction < 0 ? -1 : 1;
    if(stage) stage.classList.add('grb-gallery-is-sliding-v58');
    el.classList.remove('grb-gallery-enter-left-v58', 'grb-gallery-enter-right-v58', 'grb-gallery-exit-left-v58', 'grb-gallery-exit-right-v58');

    el.classList.add(dir > 0 ? 'grb-gallery-exit-left-v58' : 'grb-gallery-exit-right-v58');

    window.setTimeout(function(){
      if(typeof index === 'number') activeGalleryIndexV55 = index;
      el.src = src;
      updateGalleryCounterV55();

      el.classList.remove('grb-gallery-exit-left-v58', 'grb-gallery-exit-right-v58');
      el.classList.add(dir > 0 ? 'grb-gallery-enter-right-v58' : 'grb-gallery-enter-left-v58');

      // force reflow then settle to centre
      void el.offsetWidth;
      window.requestAnimationFrame(function(){
        el.classList.remove('grb-gallery-enter-left-v58', 'grb-gallery-enter-right-v58');
        window.setTimeout(function(){
          if(stage) stage.classList.remove('grb-gallery-is-sliding-v58');
          if(typeof classifyGrbImageRatioV57 === 'function') classifyGrbImageRatioV57(el);
        }, 260);
      });
    }, 150);
  }


  let activeModalGalleryIndexV60 = 0;

  function slideModalImageV60(main, src, newIndex){
    if(!main || !src) return;

    const oldIndex = typeof activeModalGalleryIndexV60 === 'number' ? activeModalGalleryIndexV60 : 0;
    const nextIndex = typeof newIndex === 'number' ? newIndex : oldIndex;
    const direction = nextIndex >= oldIndex ? 1 : -1;

    const modalImages = imagesForSelections(modalSetting(),state.modalOptions) || [];
    const media = (typeof nextIndex === 'number' && modalImages[nextIndex]) ? normaliseGalleryImageV55(modalImages[nextIndex]) : null;
    if(media && media.mediaType && media.mediaType !== 'image'){
      activeModalGalleryIndexV60 = nextIndex;
      renderModalMediaV65(media);
      return;
    }
    renderModalMediaV65({mediaType:'image',src:src});

    const current = (main.currentSrc || main.src || '').split('?')[0];
    const next = String(src || '').split('?')[0];

    activeModalGalleryIndexV60 = nextIndex;

    if(current && next && current === next){
      if(typeof classifyGrbImageRatioV57 === 'function') classifyGrbImageRatioV57(main);
      return;
    }

    main.classList.remove('grb-gallery-enter-left-v58', 'grb-gallery-enter-right-v58', 'grb-gallery-exit-left-v58', 'grb-gallery-exit-right-v58');
    main.classList.add(direction > 0 ? 'grb-gallery-exit-left-v58' : 'grb-gallery-exit-right-v58');

    window.setTimeout(function(){
      main.src = src;
      main.classList.remove('grb-gallery-exit-left-v58', 'grb-gallery-exit-right-v58');
      main.classList.add(direction > 0 ? 'grb-gallery-enter-right-v58' : 'grb-gallery-enter-left-v58');

      void main.offsetWidth;

      window.requestAnimationFrame(function(){
        main.classList.remove('grb-gallery-enter-left-v58', 'grb-gallery-enter-right-v58');
        window.setTimeout(function(){
          if(typeof classifyGrbImageRatioV57 === 'function') classifyGrbImageRatioV57(main);
        }, 220);
      });
    }, 140);
  }

  function activateThumbV55(index){
    const strip = document.getElementById('grb-thumbstrip');
    if(!strip) return;
    strip.querySelectorAll('.grb__thumb').forEach(function(t, i){
      t.classList.toggle('grb__thumb--active', i === index);
    });
    const active = strip.querySelectorAll('.grb__thumb')[index];
    if(active && active.scrollIntoView) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  function goGalleryImageV55(direction){
    if(!activeGalleryImagesV55.length) return;
    const total = activeGalleryImagesV55.length;
    const nextIndex = (activeGalleryIndexV55 + direction + total) % total;
    const image = activeGalleryImagesV55[nextIndex];
    if(image && image.src) setMainImgSlideV58(image.src, nextIndex, direction);
    activateThumbV55(nextIndex);
  }

  function initGallerySwipeV55(){
    const stage = document.getElementById('grb-main-stage') || document.querySelector('.grb__mainimg');
    if(!stage || stage.dataset.grbSwipeReady === 'true') return;
    stage.dataset.grbSwipeReady = 'true';
    let startX = 0;
    let startY = 0;
    stage.addEventListener('touchstart', function(e){
      const touch = e.touches && e.touches[0];
      if(!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function(e){
      const touch = e.changedTouches && e.changedTouches[0];
      if(!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if(Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.25){
        goGalleryImageV55(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  function setMainImg(src){
    const index = activeGalleryImagesV55.findIndex(function(img){ return img && img.src === src; });
    setMainImgV55(src, index >= 0 ? index : undefined);
  }

  function buildThumbs(images){
    const strip = document.getElementById('grb-thumbstrip');
    activeGalleryImagesV55 = (images || []).map(normaliseGalleryImageV55).filter(Boolean);
    activeGalleryIndexV55 = 0;
    if(!strip){
      if(activeGalleryImagesV55[0]) setMainImgV55(activeGalleryImagesV55[0].src, 0);
      updateGalleryCounterV55();
      return;
    }
    strip.innerHTML = '';
    activeGalleryImagesV55.forEach(function(image, i){
      const d = document.createElement('div');
      d.className = 'grb__thumb' + (i === 0 ? ' grb__thumb--active' : '');
      d.setAttribute('role', 'button');
      d.setAttribute('tabindex', '0');
      const img = document.createElement('img');
      img.src = image.thumb || image.src;
      img.alt = image.altText || ('View ' + (i + 1));
      img.loading = 'lazy';
      d.appendChild(img);
      if(image.mediaType && image.mediaType !== 'image'){
        d.classList.add('grb__thumb--video-v65');
        const play = document.createElement('span');
        play.className = 'grb__play-v65';
        play.textContent = '▶';
        d.appendChild(play);
      }
      d.addEventListener('mouseenter', function(){ preloadImage(image.src); });
      d.addEventListener('touchstart', function(){ preloadImage(image.src); }, { passive: true });
      d.addEventListener('click', function(){
        const direction = i >= activeGalleryIndexV55 ? 1 : -1;
        activateThumbV55(i);
        if(image.mediaType && image.mediaType !== 'image'){
          activeGalleryIndexV55 = i;
          renderMainMediaV65(image);
          updateGalleryCounterV55();
        } else {
          setMainImgSlideV58(image.src, i, direction);
        }
      });
      d.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          d.click();
        }
      });
      strip.appendChild(d);
    });
    if(activeGalleryImagesV55[0]) setMainImgV55(activeGalleryImagesV55[0].src, 0);
    updateGalleryCounterV55();
    initGallerySwipeV55();
  }


  function classifyGrbImageRatioV57(img){
    if(!img) return;

    function apply(){
      const w = img.naturalWidth || 0;
      const h = img.naturalHeight || 0;
      if(!w || !h) return;

      const ratio = w / h;
      img.classList.remove('grb-img--portrait-v57', 'grb-img--square-v57', 'grb-img--wide-v57');

      if(ratio < 0.82){
        img.classList.add('grb-img--portrait-v57');
      } else if(ratio > 1.18){
        img.classList.add('grb-img--wide-v57');
      } else {
        img.classList.add('grb-img--square-v57');
      }
    }

    if(img.complete) apply();
    img.addEventListener('load', apply, { once: false });
  }

  function classifyAllGrbImagesV57(scope){
    const root = scope || document;
    root.querySelectorAll('#grb-main-img, .grb__mainimg img, .grb__preview-main img, .grb__modal-main img, .grb__preview-media img, .grb__preview-gallery img, .grb__preview-modal img').forEach(classifyGrbImageRatioV57);
  }

  document.addEventListener('click', function(){
    window.clearTimeout(window.grbPreviewClassifyTimeoutV57);
    window.grbPreviewClassifyTimeoutV57 = window.setTimeout(function(){
      classifyAllGrbImagesV57(document);
    }, 80);
  }, true);



  /* ==========================================================
     SARATTI GRB v66 — instant media/video selection fix
     - Removes delayed thumbnail change that required double clicks
     - Keeps video thumbnails playable in the main stage
     - Does not change thumbnail sizing or image framing CSS
     ========================================================== */

  function resolveMediaBySrcOrIndexV66(src, index){
    if(typeof index === 'number' && activeGalleryImagesV55 && activeGalleryImagesV55[index]) return activeGalleryImagesV55[index];
    const clean = String(src || '').split('?')[0];
    return (activeGalleryImagesV55 || []).find(function(item){
      if(!item) return false;
      return String(item.src || '').split('?')[0] === clean || String(item.thumb || '').split('?')[0] === clean;
    }) || null;
  }

  function setMainMediaImmediateV66(media, index){
    media = normaliseGalleryImageV55(media);
    if(!media) return;
    if(typeof index === 'number') activeGalleryIndexV55 = index;

    const stage = document.getElementById('grb-main-stage') || document.querySelector('.grb__mainimg');
    const img = document.getElementById('grb-main-img');
    if(!stage) return;

    cleanupMediaStageV65(stage);

    if(media.mediaType === 'video' && media.sources && media.sources.length){
      stage.classList.add('grb__mainimg--video-active');
      if(img) img.style.setProperty('display','none','important');
      const video = buildVideoElV65(media);
      stage.appendChild(video);
      try { video.load(); } catch(e) {}
      updateGalleryCounterV55();
      return;
    }

    if(media.mediaType === 'external_video'){
      const url = externalVideoUrlV65(media);
      if(url){
        stage.classList.add('grb__mainimg--external-video-active');
        if(img) img.style.setProperty('display','none','important');
        const iframe = document.createElement('iframe');
        iframe.className = 'grb__external-media-v65';
        iframe.src = url;
        iframe.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen','');
        stage.appendChild(iframe);
        updateGalleryCounterV55();
        return;
      }
    }

    if(img){
      img.style.removeProperty('display');
      img.loading = 'eager';
      img.decoding = 'async';
      if(media.src && img.src !== media.src) img.src = media.src;
      if(media.altText) img.alt = media.altText;
      if(typeof classifyGrbImageRatioV57 === 'function') classifyGrbImageRatioV57(img);
    }
    updateGalleryCounterV55();
  }

  function buildThumbs(images){
    const strip = document.getElementById('grb-thumbstrip');
    activeGalleryImagesV55 = (images || []).map(normaliseGalleryImageV55).filter(Boolean);
    activeGalleryIndexV55 = 0;

    if(!strip){
      if(activeGalleryImagesV55[0]) setMainMediaImmediateV66(activeGalleryImagesV55[0], 0);
      updateGalleryCounterV55();
      return;
    }

    strip.innerHTML = '';
    activeGalleryImagesV55.forEach(function(image, i){
      const d = document.createElement('div');
      d.className = 'grb__thumb' + (i === 0 ? ' grb__thumb--active' : '');
      d.setAttribute('role', 'button');
      d.setAttribute('tabindex', '0');
      d.setAttribute('aria-label', image.mediaType === 'video' || image.mediaType === 'external_video' ? 'Play media ' + (i + 1) : 'View image ' + (i + 1));

      const img = document.createElement('img');
      img.src = image.thumb || image.src;
      img.alt = image.altText || ('View ' + (i + 1));
      img.loading = i < 2 ? 'eager' : 'lazy';
      img.decoding = 'async';
      d.appendChild(img);

      if(image.mediaType && image.mediaType !== 'image'){
        d.classList.add('grb__thumb--video-v65');
        const play = document.createElement('span');
        play.className = 'grb__play-v65';
        play.textContent = '▶';
        d.appendChild(play);
      }

      d.addEventListener('mouseenter', function(){ preloadImage(image.src); });
      d.addEventListener('touchstart', function(){ preloadImage(image.src); }, { passive: true });
      d.addEventListener('click', function(){
        activateThumbV55(i);
        setMainMediaImmediateV66(image, i);
      });
      d.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          d.click();
        }
      });
      strip.appendChild(d);
    });

    if(activeGalleryImagesV55[0]) setMainMediaImmediateV66(activeGalleryImagesV55[0], 0);
    updateGalleryCounterV55();
    initGallerySwipeV55();
  }

  function setMainImg(src){
    const index = activeGalleryImagesV55.findIndex(function(img){
      return img && (img.src === src || img.thumb === src);
    });
    const media = resolveMediaBySrcOrIndexV66(src, index >= 0 ? index : undefined) || {mediaType:'image', src:src, thumb:src};
    setMainMediaImmediateV66(media, index >= 0 ? index : undefined);
  }


  window.GRB={openProcessStep,openHintModal,openCustomDesignModal,openPrivateInquiry,closeSoftModals,stickyAction,goTab,pickSetting,pickSize,pickEngraving,toggleAcc,togglePreviewTab,toggleModalDescription,openProcessModal,closeProcessModal,closeProcessModalOutside,setProcessVisual,openFinalStoneView,openFinalSettingPreview,openPreview,closePreview,closePreviewOutside,modalPickOption,openVariantGuide,confirmPreview,closeDrawer,closeDrawerOutside,openSizeGuide,addLooseToCart,addToCart,requestConsultation,setImage:(src,el)=>{const thumbs=Array.from(document.querySelectorAll('.grb__thumb')); const idx=el?thumbs.indexOf(el):-1; thumbs.forEach(t=>t.classList.remove('grb__thumb--active')); if(el)el.classList.add('grb__thumb--active'); const media=(typeof resolveMediaBySrcOrIndexV66==='function')?resolveMediaBySrcOrIndexV66(src,idx>=0?idx:undefined):null; if(typeof setMainMediaImmediateV66==='function')setMainMediaImmediateV66(media||{mediaType:'image',src:src,thumb:src},idx>=0?idx:undefined); else setMainImg(src);}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init); else init();
})();

try{ document.addEventListener('DOMContentLoaded', initVideoMediaV64); }catch(e){}


/* ==========================================================
   SARATTI GRB v67 — tiny approved patch only
   Desktop: hover zoom on selected media.
   Mobile/touch: tap selected media to open fullscreen viewer.
   ========================================================== */
(function(){
  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function isFinePointer(){ return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches; }

  function getMainStage(){ return document.getElementById('grb-main-stage') || q('#grb .grb__mainimg'); }
  function getStageMedia(stage){
    if(!stage) return null;
    return q('video, iframe, #grb-main-img, img', stage);
  }

  function ensureViewer(){
    var viewer = document.getElementById('grb-zoom-viewer-v67');
    if(viewer) return viewer;
    viewer = document.createElement('div');
    viewer.id = 'grb-zoom-viewer-v67';
    viewer.className = 'grb-zoom-viewer-v67';
    viewer.setAttribute('aria-hidden','true');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'grb-zoom-close-v67';
    close.setAttribute('aria-label','Close');
    close.innerHTML = '&times;';
    viewer.appendChild(close);
    close.addEventListener('click', closeViewer);
    viewer.addEventListener('click', function(e){ if(e.target === viewer) closeViewer(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeViewer(); });
    document.body.appendChild(viewer);
    return viewer;
  }

  function closeViewer(){
    var viewer = document.getElementById('grb-zoom-viewer-v67');
    if(!viewer) return;
    viewer.classList.remove('is-open-v67');
    viewer.setAttribute('aria-hidden','true');
    qa('img, video, iframe', viewer).forEach(function(node){ node.remove(); });
    document.documentElement.classList.remove('grb-zoom-lock-v67');
    document.body.classList.remove('grb-zoom-lock-v67');
  }

  function openViewerFromStage(stage){
    var media = getStageMedia(stage);
    if(!media) return;
    var viewer = ensureViewer();
    qa('img, video, iframe', viewer).forEach(function(node){ node.remove(); });

    var clone;
    var tag = media.tagName ? media.tagName.toLowerCase() : '';

    if(tag === 'video'){
      clone = media.cloneNode(true);
      clone.controls = true;
      clone.playsInline = true;
      clone.setAttribute('playsinline','');
      clone.setAttribute('webkit-playsinline','');
    } else if(tag === 'iframe'){
      clone = media.cloneNode(true);
    } else {
      clone = new Image();
      clone.src = media.currentSrc || media.src;
      clone.alt = media.alt || '';
      clone.decoding = 'async';
    }

    viewer.appendChild(clone);
    document.documentElement.classList.add('grb-zoom-lock-v67');
    document.body.classList.add('grb-zoom-lock-v67');
    requestAnimationFrame(function(){
      viewer.classList.add('is-open-v67');
      viewer.setAttribute('aria-hidden','false');
      if(clone && clone.tagName && clone.tagName.toLowerCase() === 'video'){
        try { clone.play(); } catch(e) {}
      }
    });
  }

  function bindZoom(){
    var stage = getMainStage();
    if(!stage || stage.dataset.grbZoomV67 === '1') return;
    stage.dataset.grbZoomV67 = '1';
    stage.classList.add('grb-zoom-ready-v67');

    stage.addEventListener('mousemove', function(e){
      if(!isFinePointer()) return;
      var media = getStageMedia(stage);
      if(media && /^(video|iframe)$/i.test(media.tagName || '')) return;
      var r = stage.getBoundingClientRect();
      if(!r.width || !r.height) return;
      stage.style.setProperty('--grb-zoom-x-v67', (((e.clientX - r.left) / r.width) * 100).toFixed(2) + '%');
      stage.style.setProperty('--grb-zoom-y-v67', (((e.clientY - r.top) / r.height) * 100).toFixed(2) + '%');
      stage.classList.add('is-zooming-v67');
      var img = q('#grb-main-img', stage);
      if(img) img.classList.add('grb-zoom-active-v67');
    });

    stage.addEventListener('mouseleave', function(){
      stage.classList.remove('is-zooming-v67');
      var img = q('#grb-main-img', stage);
      if(img) img.classList.remove('grb-zoom-active-v67');
    });

    stage.addEventListener('click', function(e){
      var tag = e.target && e.target.tagName ? e.target.tagName.toLowerCase() : '';
      if(tag === 'video' || tag === 'iframe' || tag === 'source') return;
      if(isFinePointer()) return;
      e.preventDefault();
      openViewerFromStage(stage);
    }, true);
  }

  function initV67(){
    bindZoom();
    var root = document.getElementById('grb');
    if(root && !root.dataset.grbZoomObserverV67){
      root.dataset.grbZoomObserverV67 = '1';
      new MutationObserver(function(){ bindZoom(); }).observe(root, { childList: true, subtree: true });
    }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initV67);
  else initV67();
})();

/* ============================================================
   SARATTI GRB — FINAL CLEAN STABILIZER
   Stable finalise state, private inquiry modal, form success helpers,
   service link protection, and video thumbnail safety.
   ============================================================ */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el && value) el.textContent = value;
  }

  function getCleanPriceText() {
    var price = qs('#grb-sticky-price') || qs('.grb__price') || qs('#grb-header-price');
    return price ? price.textContent.trim() : '';
  }

  function getBuildDetailsText() {
    var parts = [];
    var stone = qs('#grb-sum-stone-name');
    var setting = qs('#grb-sum-setting');
    var option = qs('#grb-final-setting-options');
    var size = qs('#grb-sum-size');
    var engraving = qs('#grb-sum-eng');
    if (stone && stone.textContent.trim()) parts.push(stone.textContent.trim());
    if (setting && setting.textContent.trim()) parts.push(setting.textContent.trim());
    if (option && option.textContent.trim()) parts.push(option.textContent.trim());
    if (size && size.textContent.trim()) parts.push('Ring size: ' + size.textContent.trim());
    if (engraving && engraving.textContent.trim()) parts.push('Engraving: ' + engraving.textContent.trim());
    return parts.join(' | ');
  }

  function hydrateModalFields(prefix) {
    var title = qs('#grb-sticky-title') || qs('#grb-stone-title') || qs('#grb-final-setting-title');
    var sub = qs('#grb-sticky-sub') || qs('#grb-final-setting-options');
    var img = qs('#grb-main-img') || qs('#grb-final-stone-img') || qs('#grb-hint-product-img-v49');
    var build = getBuildDetailsText();

    if (prefix === 'private') {
      setText('grb-private-product-title-v49', title && title.textContent.trim() ? title.textContent.trim() : document.title);
      setText('grb-private-product-sub-v49', sub && sub.textContent.trim() ? sub.textContent.trim() : getCleanPriceText());
      var privateImg = qs('#grb-private-product-img-v49');
      if (privateImg && img && (img.currentSrc || img.src)) privateImg.src = img.currentSrc || img.src;
      var privateBuild = qs('#grb-private-build-details-v49');
      if (privateBuild) privateBuild.value = build;
    }

    var hintBuild = qs('#grb-hint-build-details-v49');
    if (hintBuild) hintBuild.value = build;
    var customBuild = qs('#grb-custom-build-details-v49');
    if (customBuild) customBuild.value = build;
  }

  function openSoftModalById(id, prefix, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    hydrateModalFields(prefix || '');
    var modal = document.getElementById(id);
    if (!modal) return false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('grb-modal-lock');
    document.body.classList.add('grb-modal-lock');
    var first = qs('input, textarea, select, button', modal);
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
    return true;
  }

  function updateFinaliseState() {
    var grb = document.getElementById('grb');
    var finalPanel = document.getElementById('grb-panel-2');
    if (!grb || !finalPanel) return;
    grb.classList.toggle('grb--finalise-active', finalPanel.classList.contains('grb__panel--active'));
  }

  function protectServiceCards() {
    qsa('#grb .grb__service-card-v49').forEach(function (card) {
      var href = (card.getAttribute('href') || '').trim();
      if (!href || href === '#') {
        card.setAttribute('aria-disabled', 'true');
        card.addEventListener('click', function (e) { e.preventDefault(); }, { passive: false });
      }
    });
  }

  function markVideoThumbs() {
    qsa('#grb .grb__thumb, #grb-preview-modal .grb__mthumb').forEach(function (thumb) {
      var hasVideo = thumb.classList.contains('grb__thumb--video-v65') || thumb.classList.contains('grb__mthumb--video-v65') || !!thumb.querySelector('video, iframe, [data-media-type="video"], [data-media-type="external_video"]');
      thumb.classList.toggle('grb__thumb--video-v65', hasVideo && thumb.classList.contains('grb__thumb'));
      thumb.classList.toggle('grb__mthumb--video-v65', hasVideo && thumb.classList.contains('grb__mthumb'));
    });
  }

  function normaliseAssistText() {
    qsa('#grb .grb__link-action-v49').forEach(function (btn) {
      var text = (btn.textContent || '').trim().toLowerCase();
      if (text.indexOf('send') > -1 && text.indexOf('hint') > -1) btn.textContent = 'SEND A HINT';
      if (text.indexOf('private') > -1 && text.indexOf('inquiry') > -1) btn.textContent = 'MAKE A PRIVATE INQUIRY';
    });
  }

  function bindFormSuccessHelpers() {
    qsa('#grb .grb__modal-form-v49').forEach(function (form) {
      if (form.dataset.grbSuccessReady === 'true') return;
      form.dataset.grbSuccessReady = 'true';
      form.addEventListener('submit', function () {
        var btn = qs('[type="submit"]', form);
        if (btn) {
          btn.dataset.originalText = btn.textContent;
          btn.textContent = 'Sending…';
          btn.setAttribute('aria-busy', 'true');
        }
      });
    });
  }

  function run() {
    updateFinaliseState();
    protectServiceCards();
    markVideoThumbs();
    normaliseAssistText();
    bindFormSuccessHelpers();
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('click', function () { setTimeout(run, 80); }, true);
  document.addEventListener('change', function () { setTimeout(run, 80); }, true);
  setInterval(run, 700);

  function installOverrides() {
    if (!window.GRB) return;
    if (!window.GRB._sarattiFinalCleanOverrides) {
      window.GRB._sarattiFinalCleanOverrides = true;
      window.GRB.openPrivateInquiry = function (event) {
        return openSoftModalById('grb-private-inquiry-modal-v49', 'private', event) || openSoftModalById('grb-custom-design-modal-v49', 'custom', event);
      };
    }
  }

  installOverrides();
  document.addEventListener('DOMContentLoaded', installOverrides);
  window.addEventListener('load', installOverrides);
  setTimeout(installOverrides, 300);
})();



/* ============================================================
   SARATTI GRB v69 — final approved stabilizer
   Keeps selected video inside the main media frame and keeps
   inquiry / hint forms clean after Shopify contact submission.
   ============================================================ */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function keepVideoStageClean() {
    qsa('#grb-main-stage, #grb-preview-modal .grb__modal-main').forEach(function (stage) {
      var video = qs('.grb__video-media-v65, .grb__external-media-v65', stage);
      var img = qs('#grb-main-img, #grb-modal-main-img', stage);
      if (video) {
        stage.classList.add('grb__mainimg--video-active');
        if (img) img.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function bindSuccessMemory() {
    qsa('#grb .grb__modal-form-v49').forEach(function (form) {
      if (form.dataset.grbV69SuccessBound === 'true') return;
      form.dataset.grbV69SuccessBound = 'true';
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem('grbLastSubmittedForm', form.id || 'grb-form'); } catch (e) {}
      });
    });
  }

  function run() {
    keepVideoStageClean();
    bindSuccessMemory();
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('click', function () { window.setTimeout(run, 30); }, true);
})();
/* ==========================================================
   SARATTI GRB v70 — Gemstone specification metafield parser
   Keeps the clean specification table and preserves all extra
   metafield copy underneath.
   ========================================================== */

(function () {
  'use strict';

  const cfg = window.GRB_CONFIG || {};

  const SPEC_ORDER = [
    'gemstone type',
    'stone type',
    'main stone',
    'center stone',
    'centre stone',
    'carat weight',
    'weight',
    'shape',
    'cut',
    'color',
    'colour',
    'clarity',
    'dimensions',
    'measurement',
    'measurements',
    'treatment',
    'origin',
    'species',
    'variety',
    'transparency',
    'hardness',
    'luster',
    'lustre',
    'refractive index',
    'specific gravity',
    'certification',
    'certificate'
  ];

  const SPEC_KEYS = new Set(SPEC_ORDER.map(normalizeKey));

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function cleanValue(value) {
    if (value === null || value === undefined) return '';

    let output = String(value).trim();

    try {
      const parsed = JSON.parse(output);
      if (Array.isArray(parsed)) output = parsed.join(', ');
      if (typeof parsed === 'string') output = parsed;
    } catch (e) {}

    return String(output).replace(/^["']|["']$/g, '').trim();
  }

  function normalizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/colour/g, 'color')
      .replace(/certificate/g, 'certification')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function splitHtmlLines(html) {
    if (!html) return [];

    const root = document.createElement('div');
    root.innerHTML = html;

    root.querySelectorAll('br').forEach(function (br) {
      br.replaceWith(document.createTextNode('\n'));
    });

    root.querySelectorAll('p, div, li, tr, h1, h2, h3, h4, h5, h6').forEach(function (el) {
      el.appendChild(document.createTextNode('\n'));
    });

    return (root.innerText || root.textContent || '')
      .split(/\n+/)
      .map(function (line) {
        return line.replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean);
  }

  function specMatch(line) {
    const match = String(line || '').match(/^([^:：]{1,80})[:：]\s*(.+)$/);
    if (!match) return null;

    const label = cleanValue(match[1]);
    const value = cleanValue(match[2]);
    const key = normalizeKey(label);

    if (!label || !value || !SPEC_KEYS.has(key)) return null;

    return {
      label: label,
      value: value,
      key: key
    };
  }

  function parseSpecRows(html) {
    const rows = [];
    const seen = new Set();

    splitHtmlLines(html).forEach(function (line) {
      const row = specMatch(line);
      if (!row || seen.has(row.key)) return;

      seen.add(row.key);
      rows.push(row);
    });

    return rows;
  }

  function getExtraContent(html) {
    const extraLines = splitHtmlLines(html).filter(function (line) {
      return !specMatch(line);
    });

    if (!extraLines.length) return '';

    return extraLines
      .map(function (line) {
        return '<p>' + escapeHtml(line) + '</p>';
      })
      .join('');
  }

  function orderRows(rows) {
    const byKey = {};
    const ordered = [];

    (rows || []).forEach(function (row) {
      if (!byKey[row.key]) byKey[row.key] = row;
    });

    SPEC_ORDER.forEach(function (label) {
      const key = normalizeKey(label);

      if (byKey[key]) {
        ordered.push(byKey[key]);
        delete byKey[key];
      }
    });

    Object.keys(byKey).forEach(function (key) {
      ordered.push(byKey[key]);
    });

    return ordered;
  }

  function renderGemstoneSpecification() {
    const target = document.getElementById('grb-spec-table');
    const sourceHtml = cfg.gemstoneDetailsHtml || '';

    if (!target || !sourceHtml) return;

    const rows = orderRows(parseSpecRows(sourceHtml));
    const extraHtml = getExtraContent(sourceHtml);

    if (!rows.length && !extraHtml) return;

    const tableHtml = rows.length
      ? '<div class="grb__spec-table-clean">' +
          rows
            .map(function (row) {
              return (
                '<div class="grb__spec-list-row">' +
                  '<span>' + escapeHtml(row.label) + '</span>' +
                  '<strong>' + escapeHtml(row.value) + '</strong>' +
                '</div>'
              );
            })
            .join('') +
        '</div>'
      : '';

    const extraBlock = extraHtml
      ? '<div class="grb__spec-extra-rte">' + extraHtml + '</div>'
      : '';

    const finalHtml = tableHtml + extraBlock;

    if (target.innerHTML !== finalHtml) {
      target.innerHTML = finalHtml;
    }
  }

  function boot() {
    renderGemstoneSpecification();

    window.setTimeout(renderGemstoneSpecification, 150);
    window.setTimeout(renderGemstoneSpecification, 600);

    const root = document.getElementById('grb');
    if (!root) return;

    let pending = false;

    const observer = new MutationObserver(function () {
      if (pending) return;

      pending = true;

      window.requestAnimationFrame(function () {
        pending = false;
        renderGemstoneSpecification();
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================
   SARATTI GRB v71 — Floating bar scroll behaviour
   - Hide immediately while the customer scrolls
   - Reappear shortly after scrolling stops
   - Does not replace the existing builder logic
   ========================================================== */
(function () {
  'use strict';

  var scrollStopTimer = null;
  var SHOW_AFTER_STOP_MS = 170;
  var MIN_SCROLL_TO_SHOW = 80;

  function hasOpenBuilderOverlay() {
    return (
      document.documentElement.classList.contains('grb-modal-lock') ||
      document.documentElement.classList.contains('grb-process-lock') ||
      document.body.classList.contains('grb-modal-lock') ||
      document.body.classList.contains('grb-process-lock') ||
      document.querySelector('#grb-preview-modal.grb__modal-bg--open') ||
      document.querySelector('#grb-process-modal.grb__process-modal-bg--open') ||
      document.querySelector('#grb .grb__soft-modal-v49.is-open')
    );
  }

  function builderIsInView() {
    var root = document.getElementById('grb');
    if (!root) return false;

    var rect = root.getBoundingClientRect();

    return rect.bottom > 220 && rect.top < window.innerHeight - 80;
  }

  function shouldShowBar() {
    return (
      window.scrollY > MIN_SCROLL_TO_SHOW &&
      builderIsInView() &&
      !hasOpenBuilderOverlay()
    );
  }

  function getBar() {
    return document.getElementById('grb-stickybar');
  }

  function hideBarWhileScrolling() {
    var bar = getBar();
    if (!bar) return;

    bar.classList.remove('grb-scroll-paused-v71');
    bar.classList.remove('grb__stickybar--visible');
    bar.classList.add('grb-scroll-moving-v71');
    bar.setAttribute('aria-hidden', 'true');
  }

  function showBarAfterScrollStops() {
    var bar = getBar();
    if (!bar) return;

    bar.classList.remove('grb-scroll-moving-v71');

    if (shouldShowBar()) {
      bar.classList.add('grb-scroll-paused-v71');
      bar.classList.add('grb__stickybar--visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('grb-scroll-paused-v71');
      bar.classList.remove('grb__stickybar--visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  function onScroll() {
    hideBarWhileScrolling();

    window.clearTimeout(scrollStopTimer);
    scrollStopTimer = window.setTimeout(showBarAfterScrollStops, SHOW_AFTER_STOP_MS);
  }

  function bindFloatingBarBehaviour() {
    if (!document.getElementById('grb') || !getBar()) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', showBarAfterScrollStops, { passive: true });

    document.addEventListener('click', function () {
      window.setTimeout(showBarAfterScrollStops, 120);
    }, true);

    document.addEventListener('change', function () {
      window.setTimeout(showBarAfterScrollStops, 120);
    }, true);

    showBarAfterScrollStops();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFloatingBarBehaviour);
  } else {
    bindFloatingBarBehaviour();
  }
})();

/* ==========================================================
   SARATTI GRB v72 — Setting title opens preview
   - Preview button text becomes View Details
   - Only the product title opens the preview modal
   - Entire tile still selects setting as before
   ========================================================== */
(function () {
  'use strict';

  function getSettingIndexFromCard(card) {
    if (!card || !card.id) return null;

    var match = String(card.id).match(/grb-scard-(\d+)/);
    if (!match) return null;

    return Number(match[1]);
  }

  function patchSettingCards() {
    var root = document.getElementById('grb');
    if (!root) return;

    root.querySelectorAll('.grb__preview-btn').forEach(function (button) {
      if (button.textContent.trim() !== 'View Details') {
        button.textContent = 'View Details';
      }
    });

    root.querySelectorAll('.grb__scard-name').forEach(function (title) {
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-label', 'View setting details');
      title.classList.add('grb__scard-name--details-v72');
    });
  }

  function openPreviewFromTitle(event) {
    var title = event.target.closest('.grb__scard-name');
    if (!title) return;

    var card = title.closest('.grb__scard');
    var index = getSettingIndexFromCard(card);

    if (index === null || !window.GRB || typeof window.GRB.openPreview !== 'function') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    window.GRB.openPreview(event, index);
  }

  function openPreviewFromTitleKeyboard(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var title = event.target.closest('.grb__scard-name');
    if (!title) return;

    event.preventDefault();
    title.click();
  }

  function bootTitlePreviewPatch() {
    var root = document.getElementById('grb');
    if (!root) return;

    patchSettingCards();

    document.addEventListener('click', openPreviewFromTitle, true);
    document.addEventListener('keydown', openPreviewFromTitleKeyboard, true);

    var grid = document.getElementById('grb-settings-grid');
    if (grid) {
      var observer = new MutationObserver(function () {
        patchSettingCards();
      });

      observer.observe(grid, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootTitlePreviewPatch);
  } else {
    bootTitlePreviewPatch();
  }
})();
/* ==========================================================
   SARATTI GRB v77 — Make raw URLs clickable in preview modal
   - Preserves metafield formatting
   - Converts plain URLs into clickable links
   - Does not rebuild bullets, headings, or paragraphs
   ========================================================== */
(function () {
  'use strict';

  function linkifyTextNode(textNode) {
    if (!textNode || !textNode.nodeValue) return;

    var text = textNode.nodeValue;
    var urlRegex = /(https?:\/\/[^\s<]+)/g;

    if (!urlRegex.test(text)) return;

    var fragment = document.createDocumentFragment();
    var lastIndex = 0;

    text.replace(urlRegex, function (url, match, index) {
      if (index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, index)));
      }

      var cleanUrl = url.replace(/[),.;]+$/, '');
      var trailing = url.slice(cleanUrl.length);

      var a = document.createElement('a');
      a.href = cleanUrl;
      a.textContent = cleanUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.className = 'grb__preview-link-v77';

      fragment.appendChild(a);

      if (trailing) {
        fragment.appendChild(document.createTextNode(trailing));
      }

      lastIndex = index + url.length;
      return url;
    });

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  function linkifyElement(element) {
    if (!element) return;

    var walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.includes('http')) {
            return NodeFilter.FILTER_REJECT;
          }

          var parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;

          if (parent.closest('a, script, style, textarea, input')) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var nodes = [];
    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(linkifyTextNode);
  }

  function linkifyPreviewUrls() {
    var modal = document.getElementById('grb-preview-modal');
    if (!modal) return;

    modal.querySelectorAll('.grb__preview-acc-body, .grb__modal-desc-text').forEach(function (body) {
      linkifyElement(body);
    });
  }

  function boot() {
    linkifyPreviewUrls();

    document.addEventListener('click', function () {
      window.setTimeout(linkifyPreviewUrls, 80);
      window.setTimeout(linkifyPreviewUrls, 240);
    }, true);

    var modal = document.getElementById('grb-preview-modal');
    if (modal) {
      new MutationObserver(function () {
        window.requestAnimationFrame(linkifyPreviewUrls);
      }).observe(modal, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();